import React from 'react';
import { IProps } from './types';
import { Formik, Form, Field, ErrorMessage, FieldArray, getIn } from 'formik';
import { DatePicker, AutoComplete } from 'formik-antd';
import AddressComponent from 'components/AddressComponent';
import { IBuildingInfoFormValue } from 'constants/models/components/insureProcessFire/buildingInfo';
import { YesNo, YesNoType } from 'constants/enums/yesNo.enum';
import service from 'bff/services/fireProdService';
import memberProfileService from 'bff/services/memberProfileService';
import { BaseFireInsuredContent, BaseFirePolicyHolderContent, InprocessFillFormValue, InprocessFillState, KycOptionContent, PolicyholderKycInfo } from 'constants/models/components/insureProcessFire/insureProcessFill';
import { EmailDomain, KycClaim, MortgageBankCategoryContent, MortgageBankContent, Occupation, OccupationContent, SysOption } from 'bff/models/info';
import _ from 'lodash';
import { PolicyDelivery } from 'constants/enums/policyDelivery.enum';
import apiCommonService from 'bff/services/commonService';
import commonService from 'utils/commonService';
import { CodeId } from 'constants/enums/codeId.enum';
import * as Yup from 'yup';
import { mobileRegex, emailRegex, NumAndEnglishRegex } from 'utils/commonValidations';
// import moment, { Moment } from 'moment';
import moment from 'moment-timezone';
import { OccupationIdType } from 'constants/enums/occupationIdType.enum';
import { NationalType } from 'constants/enums/nationalType.enum';
import FormikFocusError from 'components/FormikFocusError';
import InputWithRegex from 'components/InputWithRegex';
import { RootReducersState } from 'redux/reducers';
import { connect } from 'react-redux';
import storageService from 'utils/storageService';
import { storageKeys } from 'constants/enums/storageKeys.enum';
import { MemberProfile } from 'bff/models/member';
import { Marriage } from 'constants/enums/marriage.enum';
import { InsuredRelation } from 'constants/enums/insuredRelation.enum';
import sweetAlertService from 'utils/sweetAlertService';
import { SweetAlertIcon } from 'constants/enums/sweetAlertIcon.enum';
import { FireCheckApplyTypeReq, FirePlanItemBaseContent, FirePlanItemCoverageOptContent, FirePlanItemIndemnifyContent, PolicyNoReq } from 'bff/models/product';
import { ApplyNoType } from 'constants/enums/applyNoType.enum';
import { RuleCheckInsuredType } from 'constants/enums/ruleCheckInsuredType.enum';
import { GeoAreaId } from 'constants/enums/geoAreaId.enum';
import { IdInfoType } from 'constants/enums/idInfoType.enum';
import { Dispatch } from 'redux';
import { setRuleValidErrorModalVisible, setMemberInfoErrorModalVisible } from 'redux/actions/modal.action';
import { RouterSettings } from 'constants/models/routerSettings';
import { FireItemType } from 'constants/enums/fireItemType';
import MemberInfoErrorModal from 'components/MemberInfoErrorModal';
import { ReturnCode } from 'constants/enums/returnCode.enum';
import { DataReq, InfoCheckmailandmobileReq } from 'bff/models/info/infoCheckmailandmobile';
import environment from 'constants/environments';

const initInsured: BaseFireInsuredContent = {
  INSURED_NATIONALITY_TYPE: '',
  INSURED_RELATION: InsuredRelation.Self,
  INSURED_RELATION_NAME: '',
  INSURED_NAME: '',
  INSURED_ID: '',
  INSURED_ID_ERRMSG: '',
  INSURED_BIRTHDAY: '',
  INSURED_MOBILE: '',
  INSURED_EMAIL_ADDR: '',
  INSURED_POST_CODE: '',
  INSURED_CITY_ID: '',
  INSURED_CITY_NAME: '',
  INSURED_AREA_ID: '',
  INSURED_AREA_NAME: '',
  INSURED_ADDRESS: '',
  SAME_INSURER: YesNo.Yes,
  INSURED_OCCUPATION_DOMAIN_ID: '',
  INSURED_OCCUPATION_DOMAIN_ID_NAME: '',
  INSURED_OCCUPATION_ID: '',
  INSURED_OCCUPATION_ID_NAME: ''
};

const initPolicyholder: BaseFirePolicyHolderContent = {
  POLICYHOLDER_NATIONALITY_TYPE: '',
  POLICYHOLDER_ID: '',
  POLICYHOLDER_ID_ERRMSG: '',
  POLICYHOLDER_NAME: '',
  POLICYHOLDER_BIRTHDAY: '',
  POLICYHOLDER_MOBILE: '',
  POLICYHOLDER_EMAIL_ADDR: '',
  POLICYHOLDER_MARRIAGE: Marriage.Single,
  POLICYHOLDER_POST_CODE: '',
  POLICYHOLDER_CITY_ID: '',
  POLICYHOLDER_CITY_NAME: '',
  POLICYHOLDER_AREA_ID: '',
  POLICYHOLDER_AREA_NAME: '',
  POLICYHOLDER_ADDRESS: '',
  POLICYHOLDER_OCCUPATION_DOMAIN_ID: '',
  POLICYHOLDER_OCCUPATION_DOMAIN_ID_NAME: '',
  POLICYHOLDER_OCCUPATION_ID: '',
  POLICYHOLDER_OCCUPATION_ID_NAME: '',
  POLICYHOLDER_KYC_INFOS: new Array(0),
  UPDATE_INFO_CHECKED: false
};

const initFormVal: InprocessFillFormValue = {
  POLICYHOLDERS: [{ ...initPolicyholder }],
  INSUREDS: [{ ...initInsured }],
  HAS_MORTGAGE: YesNoType.No,
  LENDER: YesNo.Yes,
  MORTGAGEE_CODE: '',
  MORTGAGEE_BANK: '',
  MORTGAGEE_BANK_NAME: '',
  MORTGAGEE_BANK_BRANCH: '',
  MORTGAGEE_BANK_BRANCH_NAME: '',
  SEND_MORTGAGEE_BANK: '',
  BANK_HANDLE_RECIPIENT: '',
  BANK_RECEIVING_POST_CODE: '',
  BANK_RECEIVING_CITY_ID: '',
  BANK_CITY_NAME: '',
  BANK_RECEIVING_AREA_ID: '',
  BANK_AREA_NAME: '',
  BANK_RECEIVING_ADDRESS: '',
  DELIVERY: PolicyDelivery.Paper
};

let formInitialValues = initFormVal;
// 判斷是否顯示會員資料錯誤 Modal
let showMemberInfoErrorModal = false;

class InsureProcessFill extends React.Component<IProps, InprocessFillState> {
  private buildingInfoDetailsRef = React.createRef() as React.RefObject<HTMLDivElement>;
  private lastInsuredRef = React.createRef() as React.RefObject<HTMLDivElement>;
  private lastPolicyholderRef = React.createRef() as React.RefObject<HTMLDivElement>;
  private formikRef: any = React.createRef();

  // Validation Schema: 移入類別內，以取得 state 資料執行檢核
  private validationSchema = Yup.object().shape({
    POLICYHOLDERS: Yup.array().of(
      Yup.object().shape({
        POLICYHOLDER_NATIONALITY_TYPE: Yup.string().required('此為必填欄位'),
        POLICYHOLDER_ID: Yup.string().required('此為必填欄位').when('POLICYHOLDER_NATIONALITY_TYPE', (nationalityType: string, schema: any) => {
          if (nationalityType === NationalType.National) {
            return schema.length(10, '身份證長度為 10 字元').matches(/^[A-Z]\d{9}$/, '身份證格式不符');
          }
          if (nationalityType === NationalType.Foreigner) {
            return schema.length(10, '居留證長度為 10 字元');
          }

          return schema.length(8, '統一編號長度為 8 字元').matches(/^\d{8}$/, '統一編號格式不符');
        }),
        POLICYHOLDER_NAME: Yup.string().required('此為必填欄位').min(2, '姓名格式錯誤').test('contain num', '姓名格式不符', (val: string) => {
          if (val) {
            return !(/[\d]+/.test(val));
          }
          return true;
        }),
        POLICYHOLDER_BIRTHDAY: Yup.string().when('POLICYHOLDER_NATIONALITY_TYPE', (nationalityType: string, schema: any) => {
          if (nationalityType !== NationalType.Legal) {
            return schema.required('此為必填欄位').nullable();
          }

          return schema.nullable();
        }),
        POLICYHOLDER_MOBILE: Yup.string().required('此為必填欄位').test('lengthLimit', '手機號碼長度為 10 字元', val => {
          if (val) {
            return val.length === 10;
          }
          return true;
        }).test('mobile format', '手機格式不符', (val: string) => {
          if (val) {
            return mobileRegex.test(val);
          }
          return true;
        }),
        POLICYHOLDER_EMAIL_ADDR: Yup.string().required('此為必填欄位').matches(emailRegex, '電子信箱格式不符').email('電子信箱格式不符').max(50, '電子信箱長度不可超過 50 字元').test('block domain', commonService.getCodeMsg(this.props.UICodes, CodeId.W087), (val: string) => {
          if (val && emailRegex.test(val)) {
            const snippets = val.split('@'); // 符合格式後進行拆分，以利檢核
            const isBlocked = this.state.blockDomains.find(it => it.EMAIL_DOMAIN_NAME === snippets[1]);
            if (isBlocked) return false;
          }
          return true;
        }),
        POLICYHOLDER_MARRIAGE: Yup.string().when('POLICYHOLDER_NATIONALITY_TYPE', (nationalityType: string, schema: any) => {
          if (nationalityType !== NationalType.Legal) {
            return schema.required('此為必填欄位');
          }

          return schema;
        }),
        POLICYHOLDER_POST_CODE: Yup.string().required('此為必填欄位').max(6, '郵遞區號長度不可超過 6 字元'),
        POLICYHOLDER_CITY_ID: Yup.string().required('此為必填欄位'),
        POLICYHOLDER_AREA_ID: Yup.string().required('此為必填欄位'),
        POLICYHOLDER_ADDRESS: Yup.string().required('此為必填欄位').max(200, '詳細地址長度不可超過 200 字元'),
        POLICYHOLDER_OCCUPATION_DOMAIN_ID: Yup.string().when('POLICYHOLDER_NATIONALITY_TYPE', (nationalityType: string, schema: any) => {
          if (nationalityType !== NationalType.Legal) {
            return schema.required('此為必填欄位');
          }

          return schema;
        }),
        POLICYHOLDER_OCCUPATION_ID: Yup.string().when('POLICYHOLDER_OCCUPATION_DOMAIN_ID', (occupationId: OccupationIdType, schema: any) => {
          return occupationId && occupationId === OccupationIdType.Special ? schema.required('職業項目為必填欄位') : schema;
        }).nullable(),
        POLICYHOLDER_KYC_INFOS: Yup.array().of(
          Yup.object().shape({
            // KYC_ERROR: Yup.string().when('KYC_OPTIONS', (kycOpts:KycOptionContent[], schema:any) => {
            //   return kycOpts && kycOpts.length > 0 && _.every(kycOpts, (opt:KycOptionContent) => !opt.CHECKED) ? schema.required('此為必填欄位') : schema.required('');
            // }),
            KYC_ANSWER: Yup.object().shape({
              KEY: Yup.string().required('此為必填欄位'),
              INPUT_VAL: Yup.string().when('KEY', (keyVal: string, schema: any) => {
                return keyVal && keyVal === '99' ? schema.required('此為必填欄位') : schema;
              })
            })
            // KYC_OPTIONS: Yup.array()
            //   .of(
            //     Yup.object().shape({
            //       INPUT_VAL: Yup.string().when(['KEY', 'CHECKED'], {
            //         is: (KEY, CHECKED) => KEY === '99' && CHECKED,
            //         then: Yup.string().required('此為必填欄位'),
            //         otherwise: Yup.string().required('')
            //       })
            //     })
            //   )
          })
        )
      })
    ),
    INSUREDS: Yup.array().of(
      Yup.object().shape({
        INSURED_NATIONALITY_TYPE: Yup.string().required('此為必填欄位'),
        INSURED_RELATION: Yup.string().required('此為必填欄位'),
        INSURED_NAME: Yup.string().required('此為必填欄位').min(2, '姓名格式錯誤').max(200, '最大長度為 200 字元')
          .test('contain num', '姓名格式不符', (val: string) => {
            if (val) {
              return !(/[\d]+/.test(val));
            }
            return true;
          }),
        INSURED_ID: Yup.string().required('此為必填欄位')
          .when('INSURED_NATIONALITY_TYPE', (nationalityType: string, schema: any) => {
            if (nationalityType === NationalType.National) {
              return schema.length(10, '身份證長度為 10 字元').matches(/^[A-Z]\d{9}$/, '身份證格式不符');
            }
            if (nationalityType === NationalType.Foreigner) {
              return schema.length(10, '居留證長度為 10 字元');
            }

            if (nationalityType === NationalType.Legal) {
              return schema.length(8, '統一編號長度為 8 字元').matches(/^\d{8}$/, '統一編號格式不符');
            }

            return schema;
          }),
        INSURED_BIRTHDAY: Yup.string().when(['INSURED_RELATION', 'INSURED_NATIONALITY_TYPE'], {
          is: (relation, nationality) => (relation && relation === InsuredRelation.SameInsured) || (nationality && nationality === NationalType.Legal),
          then: Yup.string().nullable(),
          otherwise: Yup.string().nullable()
        }),
        INSURED_MOBILE: Yup.string().test('lengthLimit', '手機號碼長度為 10 字元', val => {
          if (val) {
            return val.length === 10;
          }
          return true;
        }).test('mobile format', '手機格式不符', (val: string) => {
          if (val) {
            return mobileRegex.test(val);
          }
          return true;
        }),
        INSURED_EMAIL_ADDR: Yup.string().matches(emailRegex, '電子信箱格式不符').email('電子信箱格式不符').max(50, '電子信箱長度不可超過 50 字元').test('block domain', commonService.getCodeMsg(this.props.UICodes, CodeId.W087), (val: string) => {
          if (val && emailRegex.test(val)) {
            const snippets = val.split('@'); // 符合格式後進行拆分，以利檢核
            const isBlocked = this.state.blockDomains.find(it => it.EMAIL_DOMAIN_NAME === snippets[1]);
            if (isBlocked) return false;
          }
          return true;
        }),
        INSURED_POST_CODE: Yup.string()
          .max(6, '郵遞區號長度不可超過 6 字元')
          .test('is-required-for-first-insured', '此為必填欄位', function (value) {
            const index = parseInt(this.path.match(/\[(\d+)]/)?.[1] ?? '0', 10);
            if (index > 0) {
              return true;
            }
            return !!value;
          }),
        INSURED_CITY_ID: Yup.string().test('is-required-for-first-insured', '此為必填欄位', function (value) {
          const index = parseInt(this.path.match(/\[(\d+)]/)?.[1] ?? '0', 10);
          if (index > 0) {
            return true;
          }
          return !!value;
        }),
        INSURED_AREA_ID: Yup.string().test('is-required-for-first-insured', '此為必填欄位', function (value) {
          const index = parseInt(this.path.match(/\[(\d+)]/)?.[1] ?? '0', 10);
          if (index > 0) {
            return true;
          }
          return !!value;
        }),
        INSURED_ADDRESS: Yup.string()
          .max(200, '詳細地址長度不可超過 200 字元')
          .test('is-required-for-first-insured', '此為必填欄位', function (value) {
            const index = parseInt(this.path.match(/\[(\d+)]/)?.[1] ?? '0', 10);
            if (index > 0) {
              return true;
            }
            return !!value;
          }),
        INSURED_OCCUPATION_DOMAIN_ID: Yup.string().when('INSURED_NATIONALITY_TYPE', (nationalityType: string, schema: any) => {
          if (nationalityType !== NationalType.Legal) {
            return schema.required('此為必填欄位');
          }
          return schema;
        }),
        INSURED_OCCUPATION_ID: Yup.string().when('INSURED_OCCUPATION_DOMAIN_ID', (occupationId: OccupationIdType, schema: any) => {
          return occupationId && occupationId === OccupationIdType.Special ? schema.required('職業項目為必填欄位') : schema;
        }).nullable()
      })
    ),
    LENDER: Yup.string().when('HAS_MORTGAGE', (hasMortgage: string, schema: any) => {
      return hasMortgage && hasMortgage === YesNoType.Yes ? schema.required('此為必填欄位') : schema;
    }),
    MORTGAGEE_CODE: Yup.string().when(['HAS_MORTGAGE', 'LENDER'], {
      is: (hasMortgage, lender) => hasMortgage && hasMortgage === YesNoType.Yes && lender && lender === YesNo.Yes,
      then: Yup.string().required('此為必填欄位'),
      otherwise: Yup.string()
    }),
    MORTGAGEE_BANK: Yup.string().when(['HAS_MORTGAGE', 'LENDER'], {
      is: (hasMortgage, lender) => hasMortgage && hasMortgage === YesNoType.Yes && lender && lender === YesNo.Yes,
      then: Yup.string().required('此為必填欄位'),
      otherwise: Yup.string()
    }),
    MORTGAGEE_BANK_BRANCH: Yup.string().when(['HAS_MORTGAGE', 'LENDER'], {
      is: (hasMortgage, lender) => hasMortgage && hasMortgage === YesNoType.Yes && lender && lender === YesNo.Yes,
      then: Yup.string(), // Yup.string().required('此為必填欄位'),
      otherwise: Yup.string()
    }),
    SEND_MORTGAGEE_BANK: Yup.string().when(['HAS_MORTGAGE', 'LENDER'], {
      is: (hasMortgage, lender) => hasMortgage && hasMortgage === YesNoType.Yes && lender && lender === YesNo.Yes,
      then: Yup.string().required('此為必填欄位'),
      otherwise: Yup.string()
    }),
    BANK_HANDLE_RECIPIENT: Yup.string().when('SEND_MORTGAGEE_BANK', (sendBank: string, schema: any) => {
      return sendBank && sendBank === YesNo.Yes ? schema.required('此為必填欄位') : schema;
    }),
    BANK_RECEIVING_POST_CODE: Yup.string().when('SEND_MORTGAGEE_BANK', (sendBank: string, schema: any) => {
      return sendBank && sendBank === YesNo.Yes ? schema.required('此為必填欄位').max(6, '郵遞區號長度不可超過 6 字元') : schema;
    }),
    BANK_RECEIVING_CITY_ID: Yup.string().when('SEND_MORTGAGEE_BANK', (sendBank: string, schema: any) => {
      return sendBank && sendBank === YesNo.Yes ? schema.required('此為必填欄位') : schema;
    }),
    BANK_RECEIVING_AREA_ID: Yup.string().when('SEND_MORTGAGEE_BANK', (sendBank: string, schema: any) => {
      return sendBank && sendBank === YesNo.Yes ? schema.required('此為必填欄位') : schema;
    }),
    BANK_RECEIVING_ADDRESS: Yup.string().when('SEND_MORTGAGEE_BANK', (sendBank: string, schema: any) => {
      return sendBank && sendBank === YesNo.Yes ? schema.required('此為必填欄位').max(200, '詳細地址長度不可超過 200 字元') : schema;
    }),
    DELIVERY: Yup.string().required('此為必填欄位')
  });

  readonly state: InprocessFillState = {
    buildingInfoDetailsOpen: true,
    policyDeliverySysOpts: new Array(0),
    relationSysOpts: new Array(0),
    relationLSysOpts: new Array(0),
    marriageSysOpts: new Array(0),
    yesnoSysOpts: new Array(0),
    nationalityVSysOpts: new Array(0),
    mortgageStatusSysOpts: new Array(0),
    emailDomains: new Array(0),
    occupations: new Array(0),
    kycClaims: new Array(0),
    mortgageBanks: new Array(0),
    activeMortgageBank: '',
    isLoginComplete: false,
    applyType: '',
    serialNo: '',
    didMount: false,
    blockDomains: [],
    hidePolicyID: false
  }

  componentDidMount = async () => {
    showMemberInfoErrorModal = false;
    const { tempSelectState } = this.props.tempSelect;
    if (!tempSelectState) return;

    commonService.scrollToTop();

    // 判斷是否有暫存資料
    const hasTemp = this.props.tempFill && this.props.tempFill.tempFillFormValue && this.props.tempFill.tempFillState;

    const memberId = storageService.getItem(storageKeys.MemberId);

    // 判斷是否已登入，並取得會員資料
    let memberProfile: any;
    if (memberId) {
      memberProfile = await memberProfileService.fetchMemberProfile(memberId) as MemberProfile;
      if (!memberProfile) return;
    }

    const { tempBuildingInfoState } = this.props.tempBuildingInfo;

    // 取得網域黑名單
    let blockDomains: EmailDomain[] = [];
    const response = await apiCommonService.fetchBlockDomains();
    if (response) blockDomains = response;

    /**
    * 依不同情況執行不同方法
    * 1. 有暫存資料、登入者 ID、尚未帶入會員資料於要本人、有會員資料
    * 2. 有暫存資料
    * 3. 無暫存資料
    * 3-1. 無暫存資料、有會員資料
    */
    if (hasTemp && memberId && !this.props.tempFill.tempFillState?.isLoginComplete && memberProfile && this.props.tempFill.tempFillFormValue && this.props.tempFill.tempFillState) {
      // console.log('進 1');
      this.setState({ hidePolicyID: true });
      formInitialValues = {
        ...formInitialValues,
        ...this.props.tempFill.tempFillFormValue
      };
      showMemberInfoErrorModal = true;
      formInitialValues = {
        ...formInitialValues,
        POLICYHOLDERS: _.map(formInitialValues.POLICYHOLDERS, (holders: BaseFirePolicyHolderContent, index: number) => {
          if (index !== 0) return { ...holders };
          const occupationNames = this.handleGetOccupationName(this.props.tempFill.tempFillState?.occupations || [], memberProfile);
          return {
            ...holders,
            POLICYHOLDER_NATIONALITY_TYPE: memberProfile.NATIONALITY_TYPE,
            POLICYHOLDER_ID: memberProfile.MEMBER_ID,
            POLICYHOLDER_NAME: memberProfile.NAME,
            POLICYHOLDER_BIRTHDAY: memberProfile.BIRTHDAY,
            POLICYHOLDER_MOBILE: memberProfile.MOBILE,
            POLICYHOLDER_EMAIL_ADDR: memberProfile.EMAIL_ADDR,
            POLICYHOLDER_MARRIAGE: memberProfile.MARRIAGE || Marriage.Single,
            POLICYHOLDER_POST_CODE: memberProfile.POST_CODE,
            POLICYHOLDER_CITY_ID: memberProfile.CITY_ID,
            POLICYHOLDER_CITY_NAME: commonService.getCityName(this.props.postcodes, memberProfile.CITY_ID || ''),
            POLICYHOLDER_AREA_ID: memberProfile.AREA_ID,
            POLICYHOLDER_AREA_NAME: commonService.getAreaName(this.props.postcodes, memberProfile.CITY_ID || '', memberProfile.AREA_ID || ''),
            POLICYHOLDER_ADDRESS: memberProfile.ADDRESS,
            POLICYHOLDER_OCCUPATION_DOMAIN_ID: memberProfile.OCCUPATION_DOMAIN_ID,
            POLICYHOLDER_OCCUPATION_ID: memberProfile.OCCUPATION_ID,
            POLICYHOLDER_OCCUPATION_DOMAIN_ID_NAME: occupationNames.OCCUPATION_DOMAIN_ID_NAME,
            POLICYHOLDER_OCCUPATION_ID_NAME: occupationNames.OCCUPATION_ID_NAME
          } as BaseFirePolicyHolderContent;
        }),
        INSUREDS: _.map(formInitialValues.INSUREDS, (insured: BaseFireInsuredContent) => {
          if (insured.INSURED_RELATION !== InsuredRelation.Self) return { ...insured };
          const occupationNames = this.handleGetOccupationName(this.props.tempFill.tempFillState?.occupations || [], memberProfile);
          return {
            ...insured,
            INSURED_NATIONALITY_TYPE: memberProfile.NATIONALITY_TYPE,
            INSURED_RELATION: InsuredRelation.Self,
            INSURED_RELATION_NAME: this.handleGetRelationName(this.props.tempFill.tempFillState?.relationSysOpts || [], InsuredRelation.Self),
            INSURED_NAME: memberProfile.NAME,
            INSURED_ID: memberProfile.MEMBER_ID,
            INSURED_BIRTHDAY: memberProfile.BIRTHDAY,
            INSURED_MOBILE: memberProfile.MOBILE,
            INSURED_EMAIL_ADDR: memberProfile.EMAIL_ADDR,
            INSURED_POST_CODE: memberProfile.POST_CODE,
            INSURED_CITY_ID: memberProfile.CITY_ID,
            INSURED_CITY_NAME: commonService.getCityName(this.props.postcodes, memberProfile.CITY_ID || ''),
            INSURED_AREA_ID: memberProfile.AREA_ID,
            INSURED_AREA_NAME: commonService.getAreaName(this.props.postcodes, memberProfile.CITY_ID || '', memberProfile.AREA_ID || ''),
            INSURED_ADDRESS: memberProfile.ADDRESS,
            SAME_INSURER: YesNo.Yes,
            INSURED_OCCUPATION_DOMAIN_ID: memberProfile.OCCUPATION_DOMAIN_ID,
            INSURED_OCCUPATION_ID: memberProfile.OCCUPATION_ID,
            INSURED_OCCUPATION_DOMAIN_ID_NAME: occupationNames.OCCUPATION_DOMAIN_ID_NAME,
            INSURED_OCCUPATION_ID_NAME: occupationNames.OCCUPATION_ID_NAME
          };
        })
      };

      this.setState({
        ...this.props.tempFill.tempFillState,
        isLoginComplete: this.props.fetchFavoriteComplete,
        blockDomains
      });
    } else if (hasTemp && this.props.tempFill.tempFillFormValue && this.props.tempFill.tempFillState) {
      // console.log('進2');
      formInitialValues = {
        ...formInitialValues,
        ...this.props.tempFill.tempFillFormValue
      };

      this.setState({
        ...this.props.tempFill.tempFillState,
        isLoginComplete: this.props.fetchFavoriteComplete,
        blockDomains
      });
    } else {
      // console.log('進3');
      const initSetting = await service.fetchInitFill(this.props.insTypeId);
      // console.log('initSetting', JSON.stringify(initSetting));
      formInitialValues = {
        ...formInitialValues,
        POLICYHOLDERS: _.map(formInitialValues.POLICYHOLDERS, (holders: any) => {
          return {
            ...holders,
            POLICYHOLDER_KYC_INFOS: this.handleGetInitKycInfo(initSetting.kycClaims)
          };
        }),
        INSUREDS: _.map(formInitialValues.INSUREDS, (insured: BaseFireInsuredContent, index: number) => {
          return {
            ...insured,
            INSURED_RELATION: InsuredRelation.Self,
            INSURED_RELATION_NAME: this.handleGetRelationName(initSetting.relationSysOpts || [], InsuredRelation.Self)
          } as BaseFireInsuredContent;
        })
      };
      // this.handleGetRelationName(this.props.tempFill.tempFillState?.relationSysOpts || [], InsuredRelation.Self)
      // console.log('formInitialValues', formInitialValues);

      if (memberProfile) {
        // console.log('進3-1');
        this.setState({ hidePolicyID: true });
        showMemberInfoErrorModal = true;
        formInitialValues = {
          ...formInitialValues,
          POLICYHOLDERS: _.map(formInitialValues.POLICYHOLDERS, (holders: BaseFirePolicyHolderContent, index: number) => {
            if (index !== 0) return { ...holders };
            const occupationNames = this.handleGetOccupationName(initSetting.occupations, memberProfile);
            return {
              ...holders,
              POLICYHOLDER_NATIONALITY_TYPE: memberProfile.NATIONALITY_TYPE,
              POLICYHOLDER_ID: memberProfile.MEMBER_ID,
              POLICYHOLDER_NAME: memberProfile.NAME,
              POLICYHOLDER_BIRTHDAY: memberProfile.BIRTHDAY,
              POLICYHOLDER_MOBILE: memberProfile.MOBILE,
              POLICYHOLDER_EMAIL_ADDR: memberProfile.EMAIL_ADDR,
              POLICYHOLDER_MARRIAGE: memberProfile.MARRIAGE || Marriage.Single,
              POLICYHOLDER_POST_CODE: memberProfile.POST_CODE,
              POLICYHOLDER_CITY_ID: memberProfile.CITY_ID,
              POLICYHOLDER_CITY_NAME: commonService.getCityName(this.props.postcodes, memberProfile.CITY_ID || ''),
              POLICYHOLDER_AREA_ID: memberProfile.AREA_ID,
              POLICYHOLDER_AREA_NAME: commonService.getAreaName(this.props.postcodes, memberProfile.CITY_ID || '', memberProfile.AREA_ID || ''),
              POLICYHOLDER_ADDRESS: memberProfile.ADDRESS,
              POLICYHOLDER_OCCUPATION_DOMAIN_ID: memberProfile.OCCUPATION_DOMAIN_ID,
              POLICYHOLDER_OCCUPATION_ID: memberProfile.OCCUPATION_ID,
              POLICYHOLDER_OCCUPATION_DOMAIN_ID_NAME: occupationNames.OCCUPATION_DOMAIN_ID_NAME,
              POLICYHOLDER_OCCUPATION_ID_NAME: occupationNames.OCCUPATION_ID_NAME
            } as BaseFirePolicyHolderContent;
          }),
          INSUREDS: _.map(formInitialValues.INSUREDS, (insured: BaseFireInsuredContent, index: number) => {
            if (index !== 0) return { ...insured };
            const occupationNames = this.handleGetOccupationName(this.props.tempFill.tempFillState?.occupations || [], memberProfile);
            return {
              ...insured,
              INSURED_NATIONALITY_TYPE: memberProfile.NATIONALITY_TYPE,
              INSURED_ID: memberProfile.MEMBER_ID,
              INSURED_NAME: memberProfile.NAME,
              INSURED_BIRTHDAY: memberProfile.BIRTHDAY,
              INSURED_MOBILE: memberProfile.MOBILE,
              INSURED_EMAIL_ADDR: memberProfile.EMAIL_ADDR,
              SAME_INSURER: YesNo.Yes,
              INSURED_POST_CODE: memberProfile.POST_CODE,
              INSURED_CITY_ID: memberProfile.CITY_ID,
              INSURED_CITY_NAME: commonService.getCityName(this.props.postcodes, memberProfile.CITY_ID || ''),
              INSURED_AREA_ID: memberProfile.AREA_ID,
              INSURED_AREA_NAME: commonService.getAreaName(this.props.postcodes, memberProfile.CITY_ID || '', memberProfile.AREA_ID || ''),
              INSURED_ADDRESS: memberProfile.ADDRESS,
              INSURED_OCCUPATION_DOMAIN_ID: memberProfile.OCCUPATION_DOMAIN_ID,
              INSURED_OCCUPATION_ID: memberProfile.OCCUPATION_ID,
              INSURED_OCCUPATION_DOMAIN_ID_NAME: occupationNames.OCCUPATION_DOMAIN_ID_NAME,
              INSURED_OCCUPATION_ID_NAME: occupationNames.OCCUPATION_ID_NAME
            } as BaseFireInsuredContent;
          })
        };
      }

      let activeMortgageBank = '';
      if (tempBuildingInfoState && tempBuildingInfoState.renewalFire) {
        // const mortInfo = this.handleGetRenewalMortInfo(tempBuildingInfoState.renewalFire.DATA.mortgagee, initSetting.mortgageBanks);
        const mortInfo = this.handleGetRenewalMortInfo(tempBuildingInfoState.renewalFire.mortgagee, initSetting.mortgageBanks);
        const mortInfoCats = this.handleGetRenewalMortInfoCategory(tempBuildingInfoState.renewalFire.mortgagee, mortInfo);

        formInitialValues = {
          ...formInitialValues,
          // LENDER: tempBuildingInfoState.renewalFire.DATA.mortFlag,
          LENDER: tempBuildingInfoState.renewalFire.mortFlag,
          MORTGAGEE_CODE: mortInfo?.HDR_ID || '',
          MORTGAGEE_BANK: mortInfo?.HDR_ID || '',
          MORTGAGEE_BANK_NAME: mortInfo?.HDR_NAME || '',
          MORTGAGEE_BANK_BRANCH: mortInfoCats?.HBRCH_ID || '',
          SEND_MORTGAGEE_BANK: tempBuildingInfoState.renewalFire.deliverBank === '1' ? YesNo.Yes : YesNo.No,
          BANK_HANDLE_RECIPIENT: tempBuildingInfoState.renewalFire.operator || '',
          BANK_CITY_NAME: this.props.postcodes.find((city) => city.CITY_ID === tempBuildingInfoState.renewalFire.cityId)?.CITY_NAME || '',
          BANK_AREA_NAME: this.props.postcodes.find((city) => city.CITY_ID === tempBuildingInfoState.renewalFire.cityId)?.AREA.find((area) => area.AREA_ID === tempBuildingInfoState.renewalFire.areaId)?.AREA_NAME || '',
          BANK_RECEIVING_CITY_ID: tempBuildingInfoState.renewalFire.cityId || '',
          BANK_RECEIVING_AREA_ID: tempBuildingInfoState.renewalFire.areaId || '',
          BANK_RECEIVING_POST_CODE: tempBuildingInfoState.renewalFire.postcode || '',
          BANK_RECEIVING_ADDRESS: tempBuildingInfoState.renewalFire.address || ''
        };

        activeMortgageBank = mortInfo?.HDR_ID || '';
      }

      // console.log('formInitialValues', formInitialValues);

      this.setState({
        policyDeliverySysOpts: [...initSetting.policyDeliverySysOpts],
        relationSysOpts: [...initSetting.relationSysOpts],
        relationLSysOpts: [...initSetting.relationLSysOpts],
        marriageSysOpts: [...initSetting.marriageSysOpts],
        yesnoSysOpts: [...initSetting.yesnoSysOpts],
        nationalityVSysOpts: [...initSetting.nationalityVSysOpts],
        emailDomains: [...initSetting.emailDomains],
        occupations: [...initSetting.occupations],
        kycClaims: [...initSetting.kycClaims],
        mortgageStatusSysOpts: [...initSetting.mortgageStatusSysOpts],
        mortgageBanks: [...initSetting.mortgageBanks],
        isLoginComplete: this.props.fetchFavoriteComplete,
        activeMortgageBank: activeMortgageBank,
        blockDomains
      });
    }

    formInitialValues = {
      ...formInitialValues,
      HAS_MORTGAGE: tempSelectState.hasMortgage,
      LENDER: this.props.tempFill?.tempFillFormValue?.LENDER || formInitialValues.LENDER,
      DELIVERY: tempSelectState.hasMortgage === YesNoType.No
        ? this.props.tempFill?.tempFillFormValue?.DELIVERY || PolicyDelivery.Electric
        : PolicyDelivery.Paper
    };

    if (tempSelectState.hasMortgage === YesNoType.No) {
      formInitialValues = {
        ...formInitialValues,
        LENDER: '',
        MORTGAGEE_CODE: '',
        MORTGAGEE_BANK: '',
        MORTGAGEE_BANK_NAME: '',
        MORTGAGEE_BANK_BRANCH: '',
        MORTGAGEE_BANK_BRANCH_NAME: '',
        SEND_MORTGAGEE_BANK: '',
        BANK_HANDLE_RECIPIENT: '',
        BANK_RECEIVING_POST_CODE: '',
        BANK_RECEIVING_CITY_ID: '',
        BANK_CITY_NAME: '',
        BANK_RECEIVING_AREA_ID: '',
        BANK_AREA_NAME: '',
        BANK_RECEIVING_ADDRESS: ''
      };
    }

    if (showMemberInfoErrorModal && commonService.checkMemberInfoError(memberProfile)) {
      this.props.setMemberInfoErrorModalVisible(
        true, '',
        commonService.getCodeMsg(this.props.UICodes, CodeId.W066),
        ['POLICYHOLDERS[0].POLICYHOLDER_MOBILE', 'POLICYHOLDERS[0].POLICYHOLDER_EMAIL_ADDR']);
    }

    this.setState({
      didMount: true,
      blockDomains
    });
    // console.log('temp State', JSON.stringify(this.props.tempState));
  }

  componentDidUpdate () {
    if (this.formikRef && this.formikRef.current) {
      _.forEach(this.formikRef.current.values.POLICYHOLDERS, (policyholder: BaseFirePolicyHolderContent, index: number) => {
        const emailInput = document.getElementById(`POLICYHOLDERS[${index}].POLICYHOLDER_EMAIL_ADDR`) as HTMLInputElement;
        if (emailInput) {
          emailInput.setAttribute('maxlength', '50');
          emailInput.setAttribute('autocomplete', 'off');
        }
      });
      _.forEach(this.formikRef.current.values.INSUREDS, (insured: BaseFireInsuredContent, index: number) => {
        const emailInput = document.getElementById(`INSUREDS[${index}].INSURED_EMAIL_ADDR`) as HTMLInputElement;
        if (emailInput) {
          emailInput.setAttribute('maxlength', '50');
          emailInput.setAttribute('autocomplete', 'off');
        }
      });
    }
  }

  componentWillUnmount () {
    if (!this.formikRef || !this.formikRef.current) return;

    const formVal = this.formikRef.current.values;

    this.props.onUnmount(formVal, this.state);

    formInitialValues = {
      ...initFormVal
    };
  }

  /**
   * @description 取得抵押權人資訊
   */
  handleGetRenewalMortInfo = (mortgageCode: string, mortgageBanks: MortgageBankContent[]) => {
    if (!mortgageCode) return;
    const mortgageCodeFrontSection = mortgageCode.slice(0, 3);
    return _.find(mortgageBanks, (mortgageBank: MortgageBankContent) => mortgageBank.HDR_ID === mortgageCodeFrontSection);
  }

  /**
   * @description 取得抵押權人資訊 (分類)
   */
  handleGetRenewalMortInfoCategory = (mortgageCode: string, mortgageBank?: MortgageBankContent) => {
    if (!mortgageCode || !mortgageBank) return;
    const mortgageCodeBackSection = mortgageCode.slice(3);
    return _.find(mortgageBank.BANK_CATEGORY, (mortgageBank) => mortgageBank.HBRCH_ID === mortgageCodeBackSection);
  };

  /**
   * @description 開啟/關閉 建築物資料詳細資訊
   */
  handleBuildingInfoDetailsToggle = () => {
    this.setState(state => ({ ...state, buildingInfoDetailsOpen: !this.state.buildingInfoDetailsOpen }));
  }

  // #region 要保人區塊相關方法

  /**
   * @description 取得登入者的職業選項名稱
   */
  handleGetOccupationName = (occupations: Occupation[], memberInfo: any) => {
    // 取得職業類別中文名稱
    let occupationIdName = '';
    let occupationDescName = '';
    if (occupations && memberInfo.OCCUPATION_DOMAIN_ID) {
      const occupationInfo = _.find(occupations, (occupation: Occupation) => occupation.OCCUPATION_DOMAIN_ID === memberInfo.OCCUPATION_DOMAIN_ID);
      if (occupationInfo) {
        occupationIdName = occupationInfo.OCCUPATION_NAME;

        const occupationContentInfo = _.find(occupationInfo.OCCUPATION, (content: OccupationContent) => content.OCCUPATION_ID === memberInfo.OCCUPATION_ID);

        if (occupationContentInfo) {
          occupationDescName = occupationContentInfo.OCCUPATION_NAME;
        }
      }
    }

    return {
      OCCUPATION_DOMAIN_ID_NAME: occupationIdName,
      OCCUPATION_ID_NAME: occupationDescName
    };
  }

  /**
   * @description 取得與要保人關係中文名稱
  */
  handleGetRelationName = (relationSysOpts: SysOption[], relationVal: string) => {
    const sysOpt = _.find(relationSysOpts, (sysOpt: SysOption) => sysOpt.PARAM_VALUE === relationVal);

    if (!sysOpt) return '';

    return sysOpt.PARAM_TEXT;
  }

  /**
   * @description 取得 KYC 初始項目資料
  */
  handleGetInitKycInfo = (kycClaims: KycClaim[]) => {
    return _.map(kycClaims, (claim: KycClaim) => {
      return {
        ...claim,
        KYC_ERROR: '',
        KYC_ANSWER: {
          KEY: '',
          VAL: '',
          TEXT: '',
          INPUT_VAL: ''
        },
        KYC_OPTIONS: claim.KYC_OPTIONS && claim.KYC_OPTIONS.length > 0
          ? _.map(claim.KYC_OPTIONS, (opt: KycOptionContent) => {
            return {
              ...opt,
              CHECKED: false,
              INPUT_VAL: ''
            };
          })
          : claim.KYC_OPTIONS
      };
    });
  }

  /**
     * @description 新增要保人區塊
    */
  handleAddPolicyholder = async (values: InprocessFillFormValue, pushAction: any, setFieldValue: any) => {
    // 判斷是否超過可投保數
    if (values.POLICYHOLDERS.length + 1 > 5) return;

    // 要保人數量 + 1 等於 2 時，進行被保人關係檢核，非本人、其他的項目清除關係
    if (values.POLICYHOLDERS.length + 1 === 2) {
      const otherName = this.handleGetRelationName(this.state.relationSysOpts || [], InsuredRelation.Other);
      for (let i = 0; i < values.INSUREDS.length; i += 1) {
        if (values.INSUREDS[i].INSURED_RELATION !== InsuredRelation.Self &&
          values.INSUREDS[i].INSURED_RELATION !== InsuredRelation.Other) {
          setFieldValue(`INSUREDS[${i}].INSURED_RELATION`, InsuredRelation.Other);
          setFieldValue(`INSUREDS[${i}].INSURED_RELATION_NAME`, otherName);
        }
      }
    }

    setTimeout(() => {
      if (this.lastPolicyholderRef && this.lastPolicyholderRef.current) {
        this.lastPolicyholderRef.current.scrollIntoView();
        // 視窗滾動高度需減去 Header 高度
        const scrolledY = window.scrollY;
        const headerHeight = 140;
        window.scroll(0, scrolledY - headerHeight);
      }
    });

    pushAction({
      ...initPolicyholder,
      POLICYHOLDER_KYC_INFOS: this.handleGetInitKycInfo(this.state.kycClaims)
    });
  }

  /**
   * @description 檢核帳號是否已存在格式是否正確
   */
  handleValidID = _.debounce(async (val: any, nationalityType?: string, index?: number, fildName?: string, fildErrorName?: string) => {
    if (!this.formikRef || !this.formikRef.current) return;
    // console.log('val', val);
    // console.log('nationalityType', nationalityType);
    let errorVal;
    const setFieldError = this.formikRef.current.setFieldError;
    const setFieldValue = this.formikRef.current.setFieldValue;
    const setFieldTouched = this.formikRef.current.setFieldTouched;

    const isNaturalValid = (nationalityType === NationalType.National || nationalityType === NationalType.Foreigner) &&
      val.length === 10;

    const insuredValid = val.length === 10 && !nationalityType;

    if (isNaturalValid || insuredValid) {
      errorVal = await memberProfileService.validMemberId(val, nationalityType).then((res: any) => res.ID);
      // console.log('errorVal', errorVal);
      setFieldError(fildName, errorVal);
      setFieldTouched(fildName, true);
      setFieldValue(fildErrorName, errorVal);
    }

    const isLegalValid = nationalityType === NationalType.Legal && val.length === 8;
    if (isLegalValid) {
      errorVal = await memberProfileService.validMemberId(val, nationalityType).then((res: any) => res.ID);
      setFieldError(fildName, errorVal);
      setFieldTouched(fildName, true);
      setFieldValue(fildErrorName, errorVal);
    }
  }, 500);

  /**
    * @description 建立職業類別項目
  */
  handleCreateOccupationOpts = (occupationDomainId: string) => {
    if (this.state.occupations.length === 0) return;

    const occupation = _.find(this.state.occupations, (occupation: Occupation, index: number) => occupation.OCCUPATION_DOMAIN_ID === occupationDomainId);

    if (!occupation) return;

    return _.map(occupation.OCCUPATION, (ocpContent: OccupationContent, index: number) => {
      return <option key={index} value={ocpContent.OCCUPATION_ID}>{ocpContent.OCCUPATION_NAME}</option>;
    });
  }

  /**
   * @description 職業類別的 Change 事件
   */
  handleOccupationDomainChange = (e: React.ChangeEvent<HTMLSelectElement>, index: number, setFieldValue: any) => {
    commonService.setSelectOptName(setFieldValue, `POLICYHOLDERS[${index}].POLICYHOLDER_OCCUPATION_DOMAIN_ID_NAME`, e.currentTarget.selectedOptions.item(0)?.text);

    if (!e.target.value || e.currentTarget.value === OccupationIdType.Special) {
      setFieldValue(`POLICYHOLDERS[${index}].POLICYHOLDER_OCCUPATION_ID`, '');
      setFieldValue(`POLICYHOLDERS[${index}].POLICYHOLDER_OCCUPATION_ID_NAME`, '');
    }

    if (e.target.value === OccupationIdType.Normal) {
      const occupation =
        _.find(this.state.occupations, (occupation: Occupation) => occupation.OCCUPATION_DOMAIN_ID === e.target.value);

      if (!occupation) return;

      setFieldValue(`POLICYHOLDERS[${index}].POLICYHOLDER_OCCUPATION_ID`, occupation.OCCUPATION[0].OCCUPATION_ID);
      setFieldValue(`POLICYHOLDERS[${index}].POLICYHOLDER_OCCUPATION_ID_NAME`, '');
    }
  }

  /**
 * @description 職業類別的 Change 事件
 */
  handleInsuredOccupationDomainChange = (e: React.ChangeEvent<HTMLSelectElement>, index: number, setFieldValue: any) => {
    commonService.setSelectOptName(setFieldValue, `INSUREDS[${index}].INSURED_OCCUPATION_DOMAIN_ID_NAME`, e.currentTarget.selectedOptions.item(0)?.text);

    if (!e.target.value || e.currentTarget.value === OccupationIdType.Special) {
      setFieldValue(`INSUREDS[${index}].INSURED_OCCUPATION_ID`, '');
      setFieldValue(`INSUREDS[${index}].INSURED_OCCUPATION_ID_NAME`, '');
    }

    if (e.target.value === OccupationIdType.Normal) {
      const occupation =
        _.find(this.state.occupations, (occupation: Occupation) => occupation.OCCUPATION_DOMAIN_ID === e.target.value);

      if (!occupation) return;

      setFieldValue(`INSUREDS[${index}].INSURED_OCCUPATION_ID`, occupation.OCCUPATION[0].OCCUPATION_ID);
      setFieldValue(`INSUREDS[${index}].INSURED_OCCUPATION_ID_NAME`, '');
    }
  }

  /**
   * @description 要保人地址更動事件
  */
  handlePolicyholderAddrChange = _.debounce((cityId: string, areaId: string, postCode: string, cityName: string, areaName: string, address: string) => {
    if (!this.formikRef || !this.formikRef.current) return;

    const val = this.formikRef.current.values as InprocessFillFormValue;
    const insureds = [...val.INSUREDS];

    // 是否有被保人卡片有勾選同要保人地址，無就離開
    if (_.every(insureds, (insured: BaseFireInsuredContent) => !insured.SAME_INSURER)) return;

    _.forEach(insureds, (insured: BaseFireInsuredContent) => {
      if (!insured.SAME_INSURER) return;

      insured.INSURED_POST_CODE = postCode;
      insured.INSURED_CITY_ID = cityId;
      insured.INSURED_CITY_NAME = cityName;
      insured.INSURED_AREA_ID = areaId;
      insured.INSURED_AREA_NAME = areaName;
      insured.INSURED_ADDRESS = address;
    });

    const setFieldValue = this.formikRef.current.setFieldValue;
    setFieldValue('INSUREDS', insureds);
  }, 500);

  /**
   * @description 要保人同步設定被保人 本人 資料
  */
  handleSetSelfInsured = (
    val: any, insureds: BaseFireInsuredContent[], fieldName: string, setFieldValue: any,
    fieldTextName?: string, fieldTextVal?: string) => {
    const selfIndex = _.findIndex(insureds, (insured: BaseFireInsuredContent) => insured.INSURED_RELATION === InsuredRelation.Self || insured.INSURED_RELATION === InsuredRelation.SameInsured);

    if (selfIndex === -1) return;

    setFieldValue(`INSUREDS[${selfIndex}].${fieldName}`, val);

    if (fieldTextName) {
      setFieldValue(`INSUREDS[${selfIndex}].${fieldTextName}`, fieldTextVal || '');
    }
  }

  /**
  * @description 要保人 email onBlur 事件
  */
  handlePolicyholderEmailBlur = (id: string, insureds: BaseFireInsuredContent[], fieldName: string, setFieldValue: any) => {
    const emailInput = document.getElementById(id) as HTMLInputElement;
    if (!emailInput) return;

    this.handleSetSelfInsured(emailInput.value, insureds, fieldName, setFieldValue);
  }
  // #endregion

  // #region 被保人區塊相關方法

  /**
   * @description 新增被保險人區塊
  */
  handleAddInsured = async (values: InprocessFillFormValue, pushAction: any) => {
    // 判斷是否超過可投保數
    if (values.INSUREDS.length + 1 > 5) return;

    setTimeout(() => {
      if (this.lastInsuredRef && this.lastInsuredRef.current) {
        this.lastInsuredRef.current.scrollIntoView();
        // 視窗滾動高度需減去 Header 高度
        const scrolledY = window.scrollY;
        const headerHeight = 140;
        window.scroll(0, scrolledY - headerHeight);
      }
    });

    pushAction({
      ...initInsured,
      INSURED_RELATION: '',
      INSURED_RELATION_NAME: '',
      SAME_INSURER: ''
    });
  }

  /**
     * @description 取得與要保險人關係下拉選單值
    */
  handleGetRelationOpts = (policyholders: BaseFirePolicyHolderContent[]) => {
    if (!policyholders || policyholders.length === 0) return;

    const relationOpts = _.map(this.state.relationSysOpts, (sysOtps: SysOption, index: number) => {
      // 要保人大於 1 人，關係欄位僅能有 本人、其他
      if (policyholders.length > 1 &&
        sysOtps.PARAM_VALUE !== InsuredRelation.Self &&
        sysOtps.PARAM_VALUE !== InsuredRelation.Other
      ) return;
      return <option key={index} value={sysOtps.PARAM_VALUE}>{sysOtps.PARAM_TEXT}</option>;
    });

    // // 若第一要保人為法人，更換與要保人關係選單項目
    // if (mainPolicyholder.POLICYHOLDER_NATIONALITY_TYPE === NationalType.Legal) {
    //   relationOpts = _.map(this.state.relationLSysOpts, (sysOtps: SysOption, index: number) => {
    //     return <option key={index} value={sysOtps.PARAM_VALUE}>{sysOtps.PARAM_TEXT}</option>;
    //   });
    // }

    return relationOpts;
  }

  /**
   * @description 與要保險人關係 Change 事件
  */
  handleInsuredRelationChange = (index: number, e: React.ChangeEvent<HTMLSelectElement>, insureds: BaseFireInsuredContent[]) => {
    if (!this.formikRef || !this.formikRef.current) return;

    const setFieldValue = this.formikRef.current.setFieldValue;
    const val = e.currentTarget.value;

    if (val === InsuredRelation.Self || val === InsuredRelation.Spouse || val === InsuredRelation.SameInsured) {
      const newInsureds = [...insureds];
      newInsureds.splice(index, 1);
      let errorMsg;
      if (val === InsuredRelation.SameInsured && _.some(newInsureds, (insured: BaseFireInsuredContent) => insured.INSURED_RELATION === InsuredRelation.SameInsured)) {
        errorMsg = '關係本人,已重覆';
      }

      if (val === InsuredRelation.Self && _.some(newInsureds, (insured: BaseFireInsuredContent) => insured.INSURED_RELATION === InsuredRelation.Self)) {
        errorMsg = '關係本人,已重覆';
      }

      if (val === InsuredRelation.Spouse && _.some(newInsureds, (insured: BaseFireInsuredContent) => insured.INSURED_RELATION === InsuredRelation.Spouse)) {
        errorMsg = '關係配偶,已重覆';
      }

      if (errorMsg) {
        sweetAlertService.modal({
          icon: SweetAlertIcon.Info,
          html: errorMsg
        });

        setFieldValue(`INSUREDS[${index}].INSURED_RELATION`, '');
        setFieldValue(`INSUREDS[${index}].INSURED_RELATION_NAME`, '');
        return;
      }
    }

    const handleChange = this.formikRef.current.handleChange;
    const insured = { ...insureds[index] };
    const formVal = this.formikRef.current.values as InprocessFillFormValue;
    const policyholders = [...formVal.POLICYHOLDERS];
    const policyholder = { ...policyholders[0] };
    const relationName = this.handleGetRelationName(
      policyholder.POLICYHOLDER_NATIONALITY_TYPE === NationalType.Legal
        ? this.state.relationSysOpts
        : this.state.relationSysOpts,
      val);

    // 與要保人關係為非本人時，清空欄位選項
    if (val !== InsuredRelation.Self && val !== InsuredRelation.SameInsured) {
      if (insured.INSURED_RELATION === InsuredRelation.Self || insured.INSURED_RELATION === InsuredRelation.SameInsured || !insured.INSURED_RELATION) {
        setFieldValue(`INSUREDS[${index}].INSURED_NATIONALITY_TYPE`, '');
        setFieldValue(`INSUREDS[${index}].INSURED_RELATION_NAME`, '');
        setFieldValue(`INSUREDS[${index}].INSURED_NAME`, '');
        setFieldValue(`INSUREDS[${index}].INSURED_ID`, '');
        setFieldValue(`INSUREDS[${index}].INSURED_BIRTHDAY`, '');
        setFieldValue(`INSUREDS[${index}].INSURED_MOBILE`, '');
        setFieldValue(`INSUREDS[${index}].INSURED_EMAIL_ADDR`, '');
        setFieldValue(`INSUREDS[${index}].INSURED_POST_CODE`, '');
        setFieldValue(`INSUREDS[${index}].INSURED_CITY_ID`, '');
        setFieldValue(`INSUREDS[${index}].INSURED_CITY_NAME`, '');
        setFieldValue(`INSUREDS[${index}].INSURED_AREA_ID`, '');
        setFieldValue(`INSUREDS[${index}].INSURED_AREA_NAME`, '');
        setFieldValue(`INSUREDS[${index}].INSURED_ADDRESS`, '');
        setFieldValue(`INSUREDS[${index}].SAME_INSURER`, '');
        setFieldValue(`INSUREDS[${index}].INSURED_OCCUPATION_DOMAIN_ID`, '');
        setFieldValue(`INSUREDS[${index}].INSURED_OCCUPATION_DOMAIN_ID_NAME`, '');
        setFieldValue(`INSUREDS[${index}].INSURED_OCCUPATION_ID`, '');
        setFieldValue(`INSUREDS[${index}].INSURED_OCCUPATION_ID_NAME`, '');
      }
      setFieldValue(`INSUREDS[${index}].INSURED_RELATION_NAME`, relationName);
      handleChange(`INSUREDS[${index}].INSURED_RELATION`)(e);
      return;
    }

    if (policyholder.POLICYHOLDER_NATIONALITY_TYPE !== NationalType.Legal) {
      setFieldValue(`INSUREDS[${index}].INSURED_BIRTHDAY`, policyholder.POLICYHOLDER_BIRTHDAY);
    }

    setFieldValue(`INSUREDS[${index}].INSURED_NATIONALITY_TYPE`, policyholder.POLICYHOLDER_NATIONALITY_TYPE);
    setFieldValue(`INSUREDS[${index}].INSURED_RELATION_NAME`, relationName);
    setFieldValue(`INSUREDS[${index}].INSURED_NAME`, policyholder.POLICYHOLDER_NAME);
    setFieldValue(`INSUREDS[${index}].INSURED_ID`, policyholder.POLICYHOLDER_ID);
    setFieldValue(`INSUREDS[${index}].INSURED_MOBILE`, policyholder.POLICYHOLDER_MOBILE);
    setFieldValue(`INSUREDS[${index}].INSURED_EMAIL_ADDR`, policyholder.POLICYHOLDER_EMAIL_ADDR);
    setFieldValue(`INSUREDS[${index}].INSURED_POST_CODE`, policyholder.POLICYHOLDER_POST_CODE);
    setFieldValue(`INSUREDS[${index}].INSURED_CITY_ID`, policyholder.POLICYHOLDER_CITY_ID);
    setFieldValue(`INSUREDS[${index}].INSURED_CITY_NAME`, policyholder.POLICYHOLDER_CITY_NAME);
    setFieldValue(`INSUREDS[${index}].INSURED_AREA_ID`, policyholder.POLICYHOLDER_AREA_ID);
    setFieldValue(`INSUREDS[${index}].INSURED_AREA_NAME`, policyholder.POLICYHOLDER_AREA_NAME);
    setFieldValue(`INSUREDS[${index}].INSURED_ADDRESS`, policyholder.POLICYHOLDER_ADDRESS);
    setFieldValue(`INSUREDS[${index}].SAME_INSURER`, YesNo.Yes);
    setFieldValue(`INSUREDS[${index}].INSURED_OCCUPATION_DOMAIN_ID`, policyholder.POLICYHOLDER_OCCUPATION_DOMAIN_ID);
    setFieldValue(`INSUREDS[${index}].INSURED_OCCUPATION_DOMAIN_ID_NAME`, policyholder.POLICYHOLDER_OCCUPATION_DOMAIN_ID_NAME);
    setFieldValue(`INSUREDS[${index}].INSURED_OCCUPATION_ID`, policyholder.POLICYHOLDER_OCCUPATION_ID);
    setFieldValue(`INSUREDS[${index}].INSURED_OCCUPATION_ID_NAME`, policyholder.POLICYHOLDER_OCCUPATION_ID_NAME);
    handleChange(`INSUREDS[${index}].INSURED_RELATION`)(e);
  }

  /**
    * @description 勾選地址同步要保人
  */
  handleSameAddress = (index: number, policyholders: BaseFirePolicyHolderContent[], setFieldValue: any) => {
    const policyholder = { ...policyholders[0] };

    setFieldValue(`INSUREDS[${index}].INSURED_POST_CODE`, policyholder.POLICYHOLDER_POST_CODE);
    setFieldValue(`INSUREDS[${index}].INSURED_CITY_ID`, policyholder.POLICYHOLDER_CITY_ID);
    setFieldValue(`INSUREDS[${index}].INSURED_CITY_NAME`, policyholder.POLICYHOLDER_CITY_NAME);
    setFieldValue(`INSUREDS[${index}].INSURED_AREA_ID`, policyholder.POLICYHOLDER_AREA_ID);
    setFieldValue(`INSUREDS[${index}].INSURED_AREA_NAME`, policyholder.POLICYHOLDER_AREA_NAME);
    setFieldValue(`INSUREDS[${index}].INSURED_ADDRESS`, policyholder.POLICYHOLDER_ADDRESS);
  }

  // #endregion

  /**
   * @description 取得電子信箱常用 Domain Name
   */
  handleGetDomainSource = (val: string) => {
    const emailDNs: any = new Array(0);
    // 有輸入值，且尚未輸入 @ 呈現常用 Domain Name 選單
    if (val && val.indexOf('@') === -1) {
      _.map(this.state.emailDomains, (emailDomain: EmailDomain) => {
        emailDNs.push({ value: `${val}@${emailDomain.EMAIL_DOMAIN_NAME}` });
      });
    }
    return emailDNs;
  }

  /**
   * @description 表單 Submit 方法
  */
  handleFormSubmit = async (values: InprocessFillFormValue) => {
    // 網要網投判斷
    const applyType = await this.handleGetApplyType(values.POLICYHOLDERS, values.INSUREDS);
    if (!applyType) return;

    const queryEarthquakeResp = await this.handleQueryEarthquake(applyType);
    if (queryEarthquakeResp && queryEarthquakeResp.MWHEADER.RETURNCODE !== ReturnCode.CodeNoInfo) {
      // 有資料時情況
      if (queryEarthquakeResp && queryEarthquakeResp.MWHEADER.RETURNCODE === ReturnCode.CodeSuccess) {
        sweetAlertService.modal({
          icon: SweetAlertIcon.Info,
          html: commonService.getCodeMsg(this.props.UICodes, CodeId.W062)
        });
        return;
      }
      // 其他錯誤
      sweetAlertService.modal({
        icon: SweetAlertIcon.Info,
        html: queryEarthquakeResp.MWHEADER.RETURNDESC
      });
      return;
    }
    // 查無資料情況

    // 取得保單號碼
    const serialNo = await this.handleGetSerialNo(applyType, values.POLICYHOLDERS);
    if (!serialNo) return;

    // 手機與電子郵件檢核 (2024/04/02)
    const verifyRes = await this.verifyMailAndMobile(values);
    if (!verifyRes) return;

    // 保單規則檢核
    const validRes = await this.handleRuleValid(values, applyType, serialNo);
    if (!validRes) return;

    if (validRes && validRes.ERROR_MSG && validRes.ERROR_MSG.length > 0) {
      this.props.setRuleValidErrorModalVisible(true, validRes.ERROR_MSG);
      return;
    }

    const newState: InprocessFillState = {
      ...this.state,
      applyType: applyType,
      serialNo: serialNo
    };

    this.setState({
      ...newState
    });

    this.props.onSubmit(values, newState);
  }

  /**
    * @description 返回上一頁
  */
  handleGoBack = (values: InprocessFillFormValue) => {
    const state = {
      ...this.state,
      isLoginComplete: this.props.fetchFavoriteComplete
    };

    this.props.onGoBack(values, state);
  }

  /**
   * @description 查詢地震基金複保險
  */
  handleQueryEarthquake = async (applyType: string) => {
    const tempBuildingInfoFormValue = this.props.tempBuildingInfo.tempBuildingInfoFormValue;
    if (tempBuildingInfoFormValue) {
      const startDate = moment(tempBuildingInfoFormValue.INSURED_DATE).format('YYYY/MM/DD');
      const endDate = moment(startDate).add(1, 'y').format('YYYY/MM/DD');

      const fullAddress = commonService.getFullAddress(
        '', tempBuildingInfoFormValue.CITY_NAME, tempBuildingInfoFormValue.AREA_NAME, tempBuildingInfoFormValue.STREET_ID_NAME, tempBuildingInfoFormValue.ADDRESS_ROADWAY,
        tempBuildingInfoFormValue.ADDRESS_ALLEY, tempBuildingInfoFormValue.ADDRESS_NUMBER, tempBuildingInfoFormValue.ADDRESS_NUMBER_OF, tempBuildingInfoFormValue.ADDRESS_FLOOR, tempBuildingInfoFormValue.ADDRESS_FLOOR_OF,
        ''
      );

      const insuredID = this.formikRef.current.values.INSUREDS.map((item: any) => item.INSURED_ID);

      return await service.queryEarthquakeFundV2(startDate, endDate, tempBuildingInfoFormValue.POST_CODE, fullAddress, insuredID, applyType);
    }
  }

  /**
   * @description 取得網要網投判斷結果
  */
  handleGetApplyType = async (policyholders: BaseFirePolicyHolderContent[], insureds: BaseFireInsuredContent[]) => {
    const req: FireCheckApplyTypeReq = {
      APPLICANT_DATA: _.map(policyholders, (holder: BaseFirePolicyHolderContent) => {
        return {
          ID: holder.POLICYHOLDER_ID,
          ID_TYPE: holder.POLICYHOLDER_NATIONALITY_TYPE
        };
      }),
      INSURED_DATA: _.map(insureds, (insured: BaseFireInsuredContent) => {
        let idType = NationalType.National;
        if (insured.INSURED_ID[1] !== IdInfoType.NationalMale && insured.INSURED_ID[1] !== IdInfoType.NationalFemale) {
          idType = NationalType.Foreigner;
        }
        return {
          ID: insured.INSURED_ID,
          ID_TYPE: idType
        };
      })
    };

    return await service.fetchApplyType(req);
  }

  /**
   * @description 取得要保單號
  */
  handleGetSerialNo = async (applyType: string, policyholders: BaseFirePolicyHolderContent[]) => {
    const req: PolicyNoReq = {
      PROD_ID: this.props.tempSelect.tempSelectState?.activeProdId || '',
      SERIAL_TYPE: ApplyNoType.WebRequire,
      BC_TYPE: applyType,
      BRANCH_ID: '',
      MEMBER_ID: policyholders[0].POLICYHOLDER_ID,
      INS_TYPE_ID: this.props.insTypeId
    };

    return await service.fetchSerialNo(req);
  }

  /**
   * @description 取得保單規則檢核要被保人資訊
  */
  handleGetConsumerDatas = (values: InprocessFillFormValue) => {
    const validDatas = _.map(values.POLICYHOLDERS, (policyholder: BaseFirePolicyHolderContent) => {
      let ocpType = OccupationIdType.RuleCheckNormal;

      switch (policyholder.POLICYHOLDER_OCCUPATION_DOMAIN_ID) {
        case OccupationIdType.Normal:
          ocpType = OccupationIdType.RuleCheckNormal;
          break;
        case OccupationIdType.Special:
          ocpType = OccupationIdType.RuleCheckSpecial;
          break;
      }

      return {
        ROLE_TYPE: RuleCheckInsuredType.Applicant,
        ID: policyholder.POLICYHOLDER_ID,
        NAME: policyholder.POLICYHOLDER_NAME,
        NATIVE_ID: policyholder.POLICYHOLDER_NATIONALITY_TYPE === NationalType.National ? GeoAreaId.Domestic : GeoAreaId.Domestic,
        OCP_TYPE: ocpType,
        ID_TYPE: policyholder.POLICYHOLDER_NATIONALITY_TYPE
      };
    });

    _.forEach(values.INSUREDS, (insured: BaseFireInsuredContent) => {
      let nativeId = GeoAreaId.Domestic;

      // 判斷是否為外國人
      if (insured.INSURED_NATIONALITY_TYPE === NationalType.Foreigner) {
        nativeId = GeoAreaId.Other;
      }

      let ocpType = OccupationIdType.RuleCheckNormal;

      switch (insured.INSURED_OCCUPATION_DOMAIN_ID) {
        case OccupationIdType.Normal:
          ocpType = OccupationIdType.RuleCheckNormal;
          break;
        case OccupationIdType.Special:
          ocpType = OccupationIdType.RuleCheckSpecial;
          break;
      }

      validDatas.push({
        ROLE_TYPE: RuleCheckInsuredType.Insured,
        ID: insured.INSURED_ID,
        NAME: insured.INSURED_NAME,
        NATIVE_ID: nativeId,
        OCP_TYPE: ocpType,
        ID_TYPE: insured.INSURED_NATIONALITY_TYPE
      });
    });

    return validDatas;
  }

  /**
   * @description 手機與電子郵件檢核
   * @param values 表單值
   */
  verifyMailAndMobile = async (values: InprocessFillFormValue) => {
    const allData: DataReq[] = [
      ...values.POLICYHOLDERS.map(it => ({
        SEQ: '',
        NAME: it.POLICYHOLDER_NAME,
        MOBILE: it.POLICYHOLDER_MOBILE,
        MAIL: it.POLICYHOLDER_EMAIL_ADDR
      })),
      ...values.INSUREDS.map(it => ({
        SEQ: '',
        NAME: it.INSURED_NAME,
        MOBILE: it.INSURED_MOBILE,
        MAIL: it.INSURED_EMAIL_ADDR
      }))
    ];
    const args: InfoCheckmailandmobileReq = {
      CHECKMAILANDMOBILE: allData.map((it, index) => ({
        ...it,
        SEQ: String(index + 1).padStart(2, '0')
      }))
    };
    const response = await apiCommonService.validMailAndMobile(args);
    if (!response) return false;
    if (response && response.CHECKMAILANDMOBILE) {
      if (response.CHECKMAILANDMOBILE.some(it => it.ISSUCCESS !== 'Y')) {
        const errorMsg: string[] = response.CHECKMAILANDMOBILE.filter(it => it.ISSUCCESS !== 'Y').map(it => it.MESSAGE);
        // 呈現多則檢核失敗
        this.props.setRuleValidErrorModalVisible(true, errorMsg);
        return false;
      }
    }
    // 檢核成功
    return true;
  }

  /**
  * @description 進行保單規則檢核
  */
  handleRuleValid = async (
    values: InprocessFillFormValue, applyType: string, serialNo: string) => {
    const { tempBuildingInfoFormValue } = this.props.tempBuildingInfo;
    const { tempSelectState, tempSelectFormValue } = this.props.tempSelect;
    if (!tempBuildingInfoFormValue || !tempSelectState || !tempSelectFormValue) return;

    const consumerDatas = this.handleGetConsumerDatas(values);

    const itemsReq = new Array(0);
    _.forEach(tempSelectFormValue.POLICY_ITEMS, (policyItem: FirePlanItemBaseContent) => {
      if (policyItem.ITEM_OPTIONAL === FireItemType.ITEM_CHECKBOX_SHOW && !policyItem.CHECKED) return;

      _.forEach(policyItem.INDEMNIFYS, (indemnify: FirePlanItemIndemnifyContent) => {
        const item: any = {
          ITEM_ID: policyItem.ITEM_ID,
          INDEMNIFY_ID: indemnify.INDEMNIFY_ID,
          VALUE: 0,
          FEE: indemnify.PREMIUM !== ''
            ? +indemnify.PREMIUM
            : null
        };

        if (indemnify.INS_COVERAGE_OPTION && indemnify.INS_COVERAGE_OPTION.length > 0) {
          _.forEach(indemnify.INS_COVERAGE_OPTION, (opt: FirePlanItemCoverageOptContent) => {
            switch (opt.TYPE) {
              case FireItemType.TYPE_INPUT:
                item.VALUE = +commonService.removeComma(`${opt.INPUT_VALUE}`);
                break;
              case FireItemType.TYPE_OPTION:
                item.VALUE = +opt.SELECT_VALUE;
                break;
              case FireItemType.TYPE_SHOW:
                item.VALUE = +commonService.removeComma(`${opt.SHOW_VALUE}`);
                break;
            }
          });
        }

        itemsReq.push(item);
      });
    });

    const req = {
      INS_TYPE_ID: this.props.insTypeId,
      PROD_ID: tempSelectState.activeProdId,
      PLAN_ID: tempSelectState.activePlanId,
      START_DATE: moment(tempBuildingInfoFormValue.INSURED_DATE).format('YYYY/MM/DD'),
      END_DATE: moment(tempBuildingInfoFormValue.INSURED_DATE).add(1, 'y').format('YYYY/MM/DD'),
      BC_TYPE: applyType,
      APPLY_NO: serialNo,
      CONSUMERS: consumerDatas,
      BUILDING: {
        POSTCODE: tempBuildingInfoFormValue.POST_CODE,
        CITY_ID: tempBuildingInfoFormValue.CITY_ID,
        AREA_ID: tempBuildingInfoFormValue.AREA_ID,
        ADDRESS_RD_ST: tempBuildingInfoFormValue.STREET_ID_NAME,
        ADDRESS_LN: tempBuildingInfoFormValue.ADDRESS_ROADWAY ? +tempBuildingInfoFormValue.ADDRESS_ROADWAY : undefined,
        ADDRESS_ALY: tempBuildingInfoFormValue.ADDRESS_ALLEY ? +tempBuildingInfoFormValue.ADDRESS_ALLEY : undefined,
        ADDRESS_NO: tempBuildingInfoFormValue.ADDRESS_NUMBER_OF
          ? `${tempBuildingInfoFormValue.ADDRESS_NUMBER}-${tempBuildingInfoFormValue.ADDRESS_NUMBER_OF}`
          : tempBuildingInfoFormValue.ADDRESS_NUMBER,
        ADDRESS_F: tempBuildingInfoFormValue.ADDRESS_FLOOR_OF && tempBuildingInfoFormValue.ADDRESS_FLOOR
          ? `${tempBuildingInfoFormValue.ADDRESS_FLOOR}-${tempBuildingInfoFormValue.ADDRESS_FLOOR_OF}`
          : tempBuildingInfoFormValue.ADDRESS_FLOOR
            ? tempBuildingInfoFormValue.ADDRESS_FLOOR
            : undefined,
        BUILDING_FLOOR: +tempBuildingInfoFormValue.FLOOR_TOTAL,
        BUILDING_BASEMENT: +tempBuildingInfoFormValue.BASEMENT_FLOOR_TOTAL,
        USAGE_AREA: parseFloat(Number.parseFloat(tempBuildingInfoFormValue.SQUARE_FEET).toFixed(2)),
        BUILDING_STRUCTURE: tempBuildingInfoFormValue.BUILDING_STRUCTURE,
        ROOF_STRUCTURE: tempBuildingInfoFormValue.ROOF_TYPE,
        BUILDING_YEAR: tempBuildingInfoFormValue.CONSTRUCTION_YEAR,
        COMMERCIAL_BUILDING: tempBuildingInfoFormValue.TRADE === YesNo.Yes ? '1' : '0',
        DECORATION_COST: +tempBuildingInfoFormValue.DECORATION_COST >= 10000 ? +tempBuildingInfoFormValue.DECORATION_COST / 10000 : +tempBuildingInfoFormValue.DECORATION_COST,
        IS_MORTGAGE: values.LENDER === YesNo.Yes ? '1' : '0',
        REPOLICY_NO: tempBuildingInfoFormValue.REPOLICY_NO ?? null
      },
      ITEMS: itemsReq
    };

    // console.log('req', JSON.stringify(req));
    return await service.policyRuleCheck(req);
  }

  handleViewToggle = () => {
    this.setState({ hidePolicyID: !this.state.hidePolicyID });
  };

  render () {
    const buildingInfoDetailsElemHeight = (this.state.buildingInfoDetailsOpen && this.buildingInfoDetailsRef && this.buildingInfoDetailsRef.current) ? this.buildingInfoDetailsRef.current.clientHeight : 0;
    const { tempBuildingInfoFormValue } = this.props.tempBuildingInfo;
    /**
     * @description 檢核要保人 ID 是否重複
     */
    const handleValidatePolicyholderId = (
      policyholderId: string, items: BaseFirePolicyHolderContent[], selfIndex: number) => {
      if (!policyholderId) return;

      for (var validIndex = 0; validIndex < items.length; validIndex += 1) {
        if (policyholderId === items[validIndex].POLICYHOLDER_ID && selfIndex !== validIndex) { return commonService.getCodeMsg(this.props.UICodes, CodeId.W059); }
      }
    };

    /**
     * @description 檢核被保人 ID 是否重複
     */
    const handleValidateInsuredId = (
      insuredId: string, items: BaseFireInsuredContent[], relation: string, mainPolicyholder: BaseFirePolicyHolderContent, selfIndex: number) => {
      if (!insuredId) return;

      if (relation !== InsuredRelation.Self && insuredId === mainPolicyholder.POLICYHOLDER_ID) { return commonService.getCodeMsg(this.props.UICodes, CodeId.W058); }

      for (var validIndex = 0; validIndex < items.length; validIndex += 1) {
        if (insuredId === items[validIndex].INSURED_ID && selfIndex !== validIndex) { return commonService.getCodeMsg(this.props.UICodes, CodeId.W059); }
      }
    };

    /**
     * @description 檢核被保人生日是否不符
     */
    const handleValidateInsuredBirthday = (policyholders: BaseFirePolicyHolderContent[], insuredId: string, birthday: any) => {
      if (!birthday || !insuredId) return '';

      const policyholder = _.find(policyholders, (policyholder: BaseFirePolicyHolderContent) =>
        policyholder.POLICYHOLDER_ID === insuredId);

      if (!policyholder || !policyholder.POLICYHOLDER_BIRTHDAY) return '';

      const policyholderBirthday = moment(policyholder.POLICYHOLDER_BIRTHDAY).format('YYYYMMDD');
      const insuredBirthday = moment(birthday).format('YYYYMMDD');

      if (moment(policyholderBirthday).isSame(moment(insuredBirthday))) return '';

      return commonService.getCodeMsg(this.props.UICodes, CodeId.W060);
    };

    /**
 * @description 檢核要保人生日是否不符
 */
    const handleValidatePolicyholderBirthday = (insureds: BaseFireInsuredContent[], policyId: string, birthday: any) => {
      if (!birthday || !policyId) return '';

      const insured = _.find(insureds, (insured: BaseFireInsuredContent) =>
        insured.INSURED_ID === policyId);

      if (!insured || !insured.INSURED_BIRTHDAY || insured.INSURED_RELATION === InsuredRelation.Self) return '';

      const insuredBirthday = moment(insured.INSURED_BIRTHDAY).format('YYYYMMDD');
      const policyholderBirthday = moment(birthday).format('YYYYMMDD');

      if (moment(policyholderBirthday).isSame(moment(insuredBirthday))) return '';

      return commonService.getCodeMsg(this.props.UICodes, CodeId.W060);
    };

    /**
     * @description 取得會員 ID 類別對應的顯示名稱
    */
    const handleGetNationalityType = (nationalityType: string) => {
      switch (nationalityType) {
        case NationalType.Foreigner:
          return '居留證號';
        case NationalType.Legal:
          return '統一編號';
        case NationalType.National:
        default:
          return '身份證字號';
      }
    };

    // #region 建築物資料區塊相關方法

    /**
     * @description 取得完整 標的物地址
    */
    const handleGetFullAddress = (values: IBuildingInfoFormValue) => {
      return commonService.getFullAddress(
        values.POST_CODE, values.CITY_NAME, values.AREA_NAME, values.STREET_ID_NAME, values.ADDRESS_ROADWAY,
        values.ADDRESS_ALLEY, values.ADDRESS_NUMBER, values.ADDRESS_NUMBER_OF, values.ADDRESS_FLOOR, values.ADDRESS_FLOOR_OF,
        values.ADDRESS_REMARK
      );
    };

    // #endregion

    // #region 抵押權人區塊相關方法

    /**
     * @description 取得抵押權人銀行下拉選單資料
    */
    const handleCreateBankOpts = () => {
      if (this.state.mortgageBanks.length === 0) return;

      return _.map(this.state.mortgageBanks, (bank: MortgageBankContent, index: number) => {
        return <option key={index} value={bank.HDR_ID}>{bank.HDR_NAME}</option>;
      });
    };

    /**
     * @description 取得抵押權人銀行分行下拉選單資料
    */
    const handleCreateBankBranchOpts = () => {
      if (!this.state.activeMortgageBank) return;

      const bank = _.find(this.state.mortgageBanks, (bank: MortgageBankContent) => bank.HDR_ID === this.state.activeMortgageBank);
      if (!bank) return;

      return _.map(bank.BANK_CATEGORY, (category: MortgageBankCategoryContent, index: number) => {
        return <option key={index} value={category.HBRCH_ID}>{`${category.HBRCH_ID} ${category.HBRCH_NAME}`}</option>;
      });
    };

    /**
     * @description 取得抵押權人銀行代碼
    */
    const handleSetMortgageCode = (bankId: string, setFieldValue: any) => {
      if (!bankId) {
        setFieldValue('MORTGAGEE_CODE', '');
        return;
      }

      const bank = _.find(this.state.mortgageBanks, (bank: MortgageBankContent) => bank.HDR_ID === bankId);
      if (!bank) return;

      setFieldValue('MORTGAGEE_CODE', bank.HDR_ID);
    };

    /**
     * @description 根據輸入的銀行代碼查詢抵押權人銀行資料
    */
    const handleGetBank = _.debounce((val: string, setFieldValue: any) => {
      if (!val || val.length !== 3 || this.state.mortgageBanks.length === 0) {
        // MORTGAGEE_BANK
        setFieldValue('MORTGAGEE_BANK', '');
        setFieldValue('MORTGAGEE_BANK_NAME', '');
        setFieldValue('MORTGAGEE_BANK_BRANCH', '');
        setFieldValue('MORTGAGEE_BANK_BRANCH_NAME', '');

        this.setState({ activeMortgageBank: '' });

        return;
      }

      const bank = _.find(this.state.mortgageBanks, (bank: MortgageBankContent) => bank.HDR_ID === val);
      if (!bank) {
        setFieldValue('MORTGAGEE_BANK', '');
        setFieldValue('MORTGAGEE_BANK_NAME', '');
        setFieldValue('MORTGAGEE_BANK_BRANCH', '');
        setFieldValue('MORTGAGEE_BANK_BRANCH_NAME', '');
        setFieldValue('MORTGAGEE_CODE', '');
        this.setState({ activeMortgageBank: '' });

        return;
      }

      setFieldValue('MORTGAGEE_BANK', bank.HDR_ID);
      setFieldValue('MORTGAGEE_BANK_NAME', bank.HDR_NAME);
      this.setState({ activeMortgageBank: bank.HDR_ID });
    }, 200);

    // #endregion

    return (
      <div className="insure-process-fill">
        <Formik
          innerRef={this.formikRef}
          initialValues={formInitialValues}
          onSubmit={this.handleFormSubmit}
          enableReinitialize
          validationSchema={this.validationSchema}
        >
          {({ values, errors, touched, handleBlur, handleChange, setFieldValue, setFieldTouched, setFieldError }) => (
            <Form>
              <div className="insure-process-fill__content">
                {/* 建築物資料 */}
                <div className="building-info">
                  {
                    tempBuildingInfoFormValue && (
                      <>
                        <div className="building-info__title">
                          <span>建築物資料</span>
                          <button
                            type="button"
                            className={'element__icon-button' + (this.state.buildingInfoDetailsOpen ? ' element__icon-button--close' : ' element__icon-button--add')}
                            onClick={this.handleBuildingInfoDetailsToggle}
                          >
                            {this.state.buildingInfoDetailsOpen ? '關閉詳細資訊' : '開啟詳細資訊'}
                          </button>
                        </div>
                        <div className="building-info__content">
                          <div className="building-info__details" style={{ height: buildingInfoDetailsElemHeight }}>
                            <div className="building-info__list" ref={this.buildingInfoDetailsRef}>
                              <div className="building-info__list-container">
                                <div className="element__list-group">
                                  <div className="element__list-group-title">標的物地址</div>
                                  <div className="element__list-group-content">{handleGetFullAddress(tempBuildingInfoFormValue)}</div>
                                </div>
                                <div className="element__list-group">
                                  <div className="element__list-group-title">總樓層數</div>
                                  <div className="element__list-group-content">
                                    {`地上層共${tempBuildingInfoFormValue.FLOOR_TOTAL}層 地下層共${tempBuildingInfoFormValue.BASEMENT_FLOOR_TOTAL}層；所在樓層第${tempBuildingInfoFormValue.CURRENT_FLOOR}層`}
                                  </div>
                                </div>
                                <div className="element__list-group">
                                  <div className="element__list-group-title">使用面積(含公設)</div>
                                  <div className="element__list-group-content">
                                    {`${+tempBuildingInfoFormValue.SQUARE_FEET}坪`}
                                  </div>
                                </div>
                                <div className="element__list-group">
                                  <div className="element__list-group-title">建築物結構</div>
                                  <div className="element__list-group-content">
                                    {tempBuildingInfoFormValue.BUILDING_STRUCTURE_NAME}
                                  </div>
                                </div>
                                <div className="element__list-group">
                                  <div className="element__list-group-title">屋頂別</div>
                                  <div className="element__list-group-content">
                                    {tempBuildingInfoFormValue.ROOF_TYPE_NAME}
                                  </div>
                                </div>
                                <div className="element__list-group">
                                  <div className="element__list-group-title">建造年份</div>
                                  <div className="element__list-group-content">
                                    {`民國${+tempBuildingInfoFormValue.CONSTRUCTION_YEAR}年`}
                                  </div>
                                </div>
                                <div className="element__list-group">
                                  <div className="element__list-group-title">同棟樓是否有營業</div>
                                  <div className="element__list-group-content">
                                    {
                                      tempBuildingInfoFormValue.TRADE === YesNo.Yes ? '是' : '否'
                                    }
                                  </div>
                                </div>
                                <div className="element__list-group">
                                  <div className="element__list-group-title">裝潢費用</div>
                                  <div className="element__list-group-content">
                                    {`${tempBuildingInfoFormValue.DECORATION_COST_NAME}`}/坪
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    )
                  }
                </div>
                {/* 要保人資料 */}
                <div className="policyholder-info" data-fieldname="POLICYHOLDERS" tabIndex={1} style={{ outline: 'none' }}>
                  <div className="policyholder-info__title">
                    <span>要保人資料</span>
                  </div>
                  <div className="policyholder-info__content">
                    <FieldArray name="POLICYHOLDERS">
                      {
                        ({ push, remove }) => (
                          <>
                            {
                              values.POLICYHOLDERS.length > 0 && (
                                _.map(values.POLICYHOLDERS, (policyholder: BaseFirePolicyHolderContent, index: number) => {
                                  return (
                                    <div className="policyholder-info__item" key={index} ref={index === values.POLICYHOLDERS.length - 1 ? this.lastPolicyholderRef : null}>
                                      <div className="policyholder-info__form">
                                        {
                                          index !== 0 && (
                                            <button
                                              type="button"
                                              className="policyholder-info__item-delete-btn"
                                              onClick={() => remove(index)}
                                            />
                                          )
                                        }
                                        <div className="element__form-table">
                                          <div className="element__form-table-tr">
                                            <div className="element__form-table-td">
                                              {/* 身份別 */}
                                              <div className={'element__form-group' + (getIn(errors, `POLICYHOLDERS[${index}].POLICYHOLDER_NATIONALITY_TYPE`) && getIn(touched, `POLICYHOLDERS[${index}].POLICYHOLDER_NATIONALITY_TYPE`) ? ' element__form-group--invalid' : '')}>
                                                <div className="element__form-group-title">證件類別*</div>
                                                <div className="element__form-group-content">
                                                  {
                                                    this.state.nationalityVSysOpts.length > 0 && (
                                                      _.map(this.state.nationalityVSysOpts, (sysOpt: SysOption, sysIndex: number) => {
                                                        return (
                                                          <div className="element__radio-group" key={sysIndex}>
                                                            <label htmlFor={`nationality-radio-${sysOpt.PARAM_VALUE}-${index}-${sysIndex}`}>
                                                              <div className="element__radio">
                                                                <Field
                                                                  type="radio"
                                                                  disabled={this.props.fetchFavoriteComplete && index === 0}
                                                                  name={`POLICYHOLDERS[${index}].POLICYHOLDER_NATIONALITY_TYPE`}
                                                                  id={`nationality-radio-${sysOpt.PARAM_VALUE}-${index}-${sysIndex}`}
                                                                  value={sysOpt.PARAM_VALUE}
                                                                  onClick={(e: React.MouseEvent<HTMLInputElement>) => {
                                                                    if (policyholder.POLICYHOLDER_NATIONALITY_TYPE !== e.currentTarget.value) {
                                                                      let marriageType: string = Marriage.Single;
                                                                      if (e.currentTarget.value === NationalType.Legal) {
                                                                        setFieldValue(`POLICYHOLDERS[${index}].POLICYHOLDER_BIRTHDAY`, '');
                                                                        setFieldValue(`POLICYHOLDERS[${index}].POLICYHOLDER_OCCUPATION_DOMAIN_ID`, '');
                                                                        setFieldValue(`POLICYHOLDERS[${index}].POLICYHOLDER_OCCUPATION_DOMAIN_ID_NAME`, '');
                                                                        setFieldValue(`POLICYHOLDERS[${index}].POLICYHOLDER_OCCUPATION_ID`, '');
                                                                        setFieldValue(`POLICYHOLDERS[${index}].POLICYHOLDER_OCCUPATION_ID_NAME`, '');
                                                                        marriageType = '';
                                                                      }
                                                                      setFieldValue(`POLICYHOLDERS[${index}].POLICYHOLDER_MARRIAGE`, marriageType);
                                                                      this.handleValidID(policyholder.POLICYHOLDER_ID, e.currentTarget.value, index, `POLICYHOLDERS[${index}].POLICYHOLDER_ID`, `POLICYHOLDERS[${index}].POLICYHOLDER_ID_ERRMSG`);
                                                                      index === 0 && this.handleSetSelfInsured(e.currentTarget.value, values.INSUREDS, 'INSURED_NATIONALITY_TYPE', setFieldValue);
                                                                    }
                                                                  }}
                                                                />
                                                                <div className="element__radio-btn" />
                                                              </div>
                                                              <span>{sysOpt.PARAM_TEXT}</span>
                                                            </label>
                                                          </div>
                                                        );
                                                      })
                                                    )
                                                  }
                                                </div>
                                                <div className="element__error-message">
                                                  <ErrorMessage name={`POLICYHOLDERS[${index}].POLICYHOLDER_NATIONALITY_TYPE`} />
                                                </div>
                                              </div>
                                            </div>
                                            {
                                              environment.debug && index === 0 && this.props.fetchFavoriteComplete && (
                                                <div className="element__form-table-td">
                                                  <div className="element__checkbox-group">
                                                    <label htmlFor="update-info-checkbox">
                                                      <div className="element__checkbox">
                                                        <Field
                                                          type="checkbox"
                                                          name={`POLICYHOLDERS[${index}].UPDATE_INFO_CHECKED`}
                                                          id="update-info-checkbox"
                                                        />
                                                        <div className="element__checkbox-btn" />
                                                      </div>
                                                      <span>同步更新至會員資料</span>
                                                    </label>
                                                  </div>
                                                </div>
                                              )
                                            }
                                          </div>
                                          <div className="element__form-table-tr">
                                            <div className="element__form-table-td">
                                              {/* 身分證字號 */}
                                              <div className={'element__form-group' + (getIn(errors, `POLICYHOLDERS[${index}].POLICYHOLDER_ID`) && getIn(touched, `POLICYHOLDERS[${index}].POLICYHOLDER_ID`) ? ' element__form-group--invalid' : '')}>
                                                <div className="element__form-group-title">{handleGetNationalityType(policyholder.POLICYHOLDER_NATIONALITY_TYPE)}*</div>
                                                {this.state.hidePolicyID && index === 0
                                                  ? <input type="text" className="element__input" value={commonService.hiddenStringLastCharacter(values.POLICYHOLDERS[0].POLICYHOLDER_ID, 5)} disabled readOnly />
                                                  : (
                                                    <Field
                                                      type="text"
                                                      disabled={this.props.fetchFavoriteComplete && index === 0}
                                                      name={`POLICYHOLDERS[${index}].POLICYHOLDER_ID`}
                                                      className="element__input"
                                                      autoComplete="off"
                                                      maxLength={10}
                                                      validate={(val: string) => {
                                                        return policyholder.POLICYHOLDER_ID_ERRMSG || handleValidatePolicyholderId(val, values.POLICYHOLDERS, index);
                                                      }}
                                                      onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                                        const val = e.currentTarget.value ? e.currentTarget.value.toUpperCase() : e.currentTarget.value;
                                                        this.handleValidID(val, policyholder.POLICYHOLDER_NATIONALITY_TYPE, index, `POLICYHOLDERS[${index}].POLICYHOLDER_ID`, `POLICYHOLDERS[${index}].POLICYHOLDER_ID_ERRMSG`);
                                                        setFieldTouched(`POLICYHOLDERS[${index}].POLICYHOLDER_ID`, true);
                                                        const errMsg = handleValidatePolicyholderId(val, values.POLICYHOLDERS, index);
                                                        if (errMsg) {
                                                          sweetAlertService.modal({
                                                            icon: SweetAlertIcon.Info,
                                                            html: errMsg
                                                          });
                                                        }
                                                        handleChange(`POLICYHOLDERS[${index}].POLICYHOLDER_ID`)(e);
                                                        setFieldValue(`POLICYHOLDERS[${index}].POLICYHOLDER_ID`, val);
                                                        index === 0 && this.handleSetSelfInsured(val, values.INSUREDS, 'INSURED_ID', setFieldValue);
                                                      }}
                                                    />)}
                                                {index === 0 &&
                                                  <button type="button" className="element__view-btn" onClick={this.handleViewToggle}>
                                                    {this.state.hidePolicyID ? <i className="fas fa-eye-slash" /> : <i className="fas fa-eye" />}
                                                  </button>}
                                                <div className="element__error-message">
                                                  <ErrorMessage name={`POLICYHOLDERS[${index}].POLICYHOLDER_ID`} />
                                                </div>
                                              </div>
                                            </div>
                                            <div className="element__form-table-td">
                                              {/* 要保人姓名 */}
                                              <div className={'element__form-group' + (getIn(errors, `POLICYHOLDERS[${index}].POLICYHOLDER_NAME`) && getIn(touched, `POLICYHOLDERS[${index}].POLICYHOLDER_NAME`) ? ' element__form-group--invalid' : '')}>
                                                <div className="element__form-group-title">要保人姓名*</div>
                                                <Field
                                                  type="text"
                                                  name={`POLICYHOLDERS[${index}].POLICYHOLDER_NAME`}
                                                  disabled={this.props.fetchFavoriteComplete && index === 0}
                                                  className="element__input"
                                                  autoComplete="off"
                                                  maxLength={200}
                                                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                                    index === 0 && this.handleSetSelfInsured(e.currentTarget.value, values.INSUREDS, 'INSURED_NAME', setFieldValue);
                                                    handleChange(e);
                                                  }}
                                                />
                                                <div className="element__error-message">
                                                  <ErrorMessage name={`POLICYHOLDERS[${index}].POLICYHOLDER_NAME`} />
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div className="element__form-table-tr">
                                            <div className="element__form-table-td">
                                              {/* 手機號碼 */}
                                              <div className={'element__form-group' + (getIn(errors, `POLICYHOLDERS[${index}].POLICYHOLDER_MOBILE`) && getIn(touched, `POLICYHOLDERS[${index}].POLICYHOLDER_MOBILE`) ? ' element__form-group--invalid' : '')}>
                                                <div className="element__form-group-title">手機號碼*</div>
                                                <Field
                                                  component={InputWithRegex}
                                                  name={`POLICYHOLDERS[${index}].POLICYHOLDER_MOBILE`}
                                                  className="element__input"
                                                  autoComplete="off"
                                                  maxLength={10}
                                                  disabled={this.props.fetchFavoriteComplete && index === 0}
                                                  onBlur={(e: React.ChangeEvent<HTMLInputElement>) => {
                                                    handleBlur(e);
                                                    setFieldTouched(`POLICYHOLDERS[${index}].POLICYHOLDER_MOBILE`, true);
                                                    index === 0 && this.handleSetSelfInsured(e.currentTarget.value, values.INSUREDS, 'INSURED_MOBILE', setFieldValue);
                                                  }}
                                                />
                                                <div className="element__error-message">
                                                  <ErrorMessage name={`POLICYHOLDERS[${index}].POLICYHOLDER_MOBILE`} />
                                                </div>
                                              </div>
                                            </div>
                                            <div className="element__form-table-td">
                                              {/* 生日 */}
                                              {
                                                policyholder.POLICYHOLDER_NATIONALITY_TYPE !== NationalType.Legal && (
                                                  <div className={'element__form-group' + (getIn(errors, `POLICYHOLDERS[${index}].POLICYHOLDER_BIRTHDAY`) && getIn(touched, `POLICYHOLDERS[${index}].POLICYHOLDER_BIRTHDAY`) ? ' element__form-group--invalid' : '')}>
                                                    <div className="element__form-group-title">生日* <span className="ant-picker-exam-info">範例： 20200101</span></div>
                                                    <DatePicker
                                                      name={`POLICYHOLDERS[${index}].POLICYHOLDER_BIRTHDAY`}
                                                      className="element__input"
                                                      disabled={this.props.fetchFavoriteComplete && index === 0}
                                                      format="YYYYMMDD"
                                                      showToday={false}
                                                      // defaultPickerValue={moment(validBirthDay)}
                                                      defaultPickerValue={moment().add(-18, 'y')}
                                                      disabledDate={(current: any) => {
                                                        return current && (current > moment().add(-18, 'y') || current < moment('1911/01/01'));
                                                        // return currentDate && (currentDate > moment(validBirthDay) || currentDate < moment('1911/01/01'));
                                                      }}
                                                      validate={(val) => {
                                                        return handleValidatePolicyholderBirthday(values.INSUREDS, policyholder.POLICYHOLDER_ID, val);
                                                      }}
                                                      onChange={(val: any) => {
                                                        index === 0 && this.handleSetSelfInsured(val, values.INSUREDS, 'INSURED_BIRTHDAY', setFieldValue);

                                                        const errMsg = handleValidatePolicyholderBirthday(values.INSUREDS, policyholder.POLICYHOLDER_ID, val);
                                                        if (errMsg) {
                                                          sweetAlertService.modal({
                                                            icon: SweetAlertIcon.Info,
                                                            html: errMsg
                                                          });
                                                        }
                                                      }}
                                                    />
                                                    <div className="element__error-message">
                                                      <ErrorMessage name={`POLICYHOLDERS[${index}].POLICYHOLDER_BIRTHDAY`} />
                                                    </div>
                                                  </div>
                                                )
                                              }
                                            </div>
                                          </div>
                                          <div className="element__form-table-tr">
                                            <div className="element__form-table-td">
                                              {/* 電子信箱 */}
                                              <div className={'element__form-group' + (getIn(errors, `POLICYHOLDERS[${index}].POLICYHOLDER_EMAIL_ADDR`) && getIn(touched, `POLICYHOLDERS[${index}].POLICYHOLDER_EMAIL_ADDR`) ? ' element__form-group--invalid' : '')}>
                                                <div className="element__form-group-title">電子信箱*</div>
                                                <AutoComplete
                                                  name={`POLICYHOLDERS[${index}].POLICYHOLDER_EMAIL_ADDR`}
                                                  id={`POLICYHOLDERS[${index}].POLICYHOLDER_EMAIL_ADDR`}
                                                  className="element__antd-input"
                                                  placeholder="請輸入電子信箱"
                                                  options={this.handleGetDomainSource(policyholder.POLICYHOLDER_EMAIL_ADDR)}
                                                  onBlur={() => index === 0 && this.handlePolicyholderEmailBlur(`POLICYHOLDERS[${index}].POLICYHOLDER_EMAIL_ADDR`, values.INSUREDS, 'INSURED_EMAIL_ADDR', setFieldValue)}
                                                />
                                                <div className="element__error-message">
                                                  <ErrorMessage name={`POLICYHOLDERS[${index}].POLICYHOLDER_EMAIL_ADDR`} />
                                                </div>
                                              </div>
                                            </div>
                                            <div className="element__form-table-td">
                                              {/* 婚姻狀況 */}
                                              {
                                                policyholder.POLICYHOLDER_NATIONALITY_TYPE !== NationalType.Legal && (
                                                  <div className={'element__form-group' + (getIn(errors, `POLICYHOLDERS[${index}].POLICYHOLDER_MARRIAGE`) && getIn(touched, `POLICYHOLDERS[${index}].POLICYHOLDER_MARRIAGE`) ? ' element__form-group--invalid' : '')}>
                                                    <div className="element__form-group-title">婚姻狀況*</div>
                                                    <div className="element__form-group-content">
                                                      {
                                                        this.state.marriageSysOpts.length > 0 && (
                                                          _.map(this.state.marriageSysOpts, (sysOpt: SysOption, sysIndex: number) => {
                                                            return (
                                                              <div className="element__radio-group" key={sysIndex}>
                                                                <label htmlFor={`marriage-radio-${sysOpt.PARAM_VALUE}-${index}-${sysIndex}`}>
                                                                  <div className="element__radio">
                                                                    <Field
                                                                      type="radio"
                                                                      disabled={this.props.fetchFavoriteComplete && index === 0}
                                                                      name={`POLICYHOLDERS[${index}].POLICYHOLDER_MARRIAGE`}
                                                                      id={`marriage-radio-${sysOpt.PARAM_VALUE}-${index}-${sysIndex}`}
                                                                      value={sysOpt.PARAM_VALUE}
                                                                    />
                                                                    <div className="element__radio-btn" />
                                                                  </div>
                                                                  <span>{sysOpt.PARAM_TEXT}</span>
                                                                </label>
                                                              </div>
                                                            );
                                                          })
                                                        )
                                                      }
                                                    </div>
                                                    <div className="element__error-message">
                                                      <ErrorMessage name={`POLICYHOLDERS[${index}].POLICYHOLDER_MARRIAGE`} />
                                                    </div>
                                                  </div>
                                                )
                                              }
                                            </div>
                                          </div>
                                          <div className="element__form-table-tr">
                                            <div className="element__form-table-td">
                                              {/* 通訊地址 */}
                                              <div className={'element__form-group' + (
                                                (getIn(errors, `POLICYHOLDERS[${index}].POLICYHOLDER_POST_CODE`) && getIn(touched, `POLICYHOLDERS[${index}].POLICYHOLDER_POST_CODE`)) ||
                                                  (getIn(errors, `POLICYHOLDERS[${index}].POLICYHOLDER_CITY_ID`) && getIn(touched, `POLICYHOLDERS[${index}].POLICYHOLDER_CITY_ID`)) ||
                                                  (getIn(errors, `POLICYHOLDERS[${index}].POLICYHOLDER_AREA_ID`) && getIn(touched, `POLICYHOLDERS[${index}].POLICYHOLDER_AREA_ID`)) ||
                                                  (getIn(errors, `POLICYHOLDERS[${index}].POLICYHOLDER_ADDRESS`) && getIn(touched, `POLICYHOLDERS[${index}].POLICYHOLDER_ADDRESS`))
                                                  ? ' element__form-group--invalid' : '')}
                                              >
                                                <div className="element__form-group-title">通訊地址*</div>
                                                <div className="element__form-group-content">
                                                  <AddressComponent
                                                    postCodeName={`POLICYHOLDERS[${index}].POLICYHOLDER_POST_CODE`}
                                                    postCodeId="postal-code-input"
                                                    cityIdName={`POLICYHOLDERS[${index}].POLICYHOLDER_CITY_ID`}
                                                    cityId="county-select"
                                                    cityIdVal={policyholder.POLICYHOLDER_CITY_ID}
                                                    cityIdText={`POLICYHOLDERS[${index}].POLICYHOLDER_CITY_NAME`}
                                                    areaIdName={`POLICYHOLDERS[${index}].POLICYHOLDER_AREA_ID`}
                                                    areaId="district-select"
                                                    areaIdVal={policyholder.POLICYHOLDER_AREA_ID}
                                                    areaNameVal={policyholder.POLICYHOLDER_AREA_NAME}
                                                    areaIdText={`POLICYHOLDERS[${index}].POLICYHOLDER_AREA_NAME`}
                                                    addressName={`POLICYHOLDERS[${index}].POLICYHOLDER_ADDRESS`}
                                                    addressVal={policyholder.POLICYHOLDER_ADDRESS}
                                                    addressId="address-input"
                                                    postcodes={this.props.postcodes}
                                                    handleBlur={handleBlur}
                                                    handleChange={handleChange}
                                                    setFieldValue={setFieldValue}
                                                    onAddressChange={index === 0 && this.handlePolicyholderAddrChange}
                                                  />
                                                </div>
                                                <div className="element__error-message">
                                                  {
                                                    getIn(errors, `POLICYHOLDERS[${index}].POLICYHOLDER_POST_CODE`) && getIn(touched, `POLICYHOLDERS[${index}].POLICYHOLDER_POST_CODE`)
                                                      ? <ErrorMessage name={`POLICYHOLDERS[${index}].POLICYHOLDER_POST_CODE`} />
                                                      : getIn(errors, `POLICYHOLDERS[${index}].POLICYHOLDER_CITY_ID`) && getIn(touched, `POLICYHOLDERS[${index}].POLICYHOLDER_CITY_ID`)
                                                        ? <ErrorMessage name={`POLICYHOLDERS[${index}].POLICYHOLDER_CITY_ID`} />
                                                        : getIn(errors, `POLICYHOLDERS[${index}].POLICYHOLDER_AREA_ID`) && getIn(touched, `POLICYHOLDERS[${index}].POLICYHOLDER_AREA_ID`)
                                                          ? <ErrorMessage name={`POLICYHOLDERS[${index}].POLICYHOLDER_AREA_ID`} />
                                                          : getIn(errors, `POLICYHOLDERS[${index}].POLICYHOLDER_ADDRESS`) && getIn(touched, `POLICYHOLDERS[${index}].POLICYHOLDER_ADDRESS`)
                                                            ? <ErrorMessage name={`POLICYHOLDERS[${index}].POLICYHOLDER_ADDRESS`} />
                                                            : ''
                                                  }
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          {/* 職業類別 */}
                                          {
                                            policyholder.POLICYHOLDER_NATIONALITY_TYPE !== NationalType.Legal && (
                                              <div className="element__form-table-tr">
                                                <div className="element__form-table-td">
                                                  <div className={'element__form-group' + (
                                                    (getIn(errors, `POLICYHOLDERS[${index}].POLICYHOLDER_OCCUPATION_DOMAIN_ID`) && getIn(touched, `POLICYHOLDERS[${index}].POLICYHOLDER_OCCUPATION_DOMAIN_ID`)) ||
                                                      (getIn(errors, `POLICYHOLDERS[${index}].POLICYHOLDER_OCCUPATION_ID`) && getIn(touched, `POLICYHOLDERS[${index}].POLICYHOLDER_OCCUPATION_ID`))
                                                      ? ' element__form-group--invalid' : '')}
                                                  >
                                                    <div className="element__form-group-title">職業類別*</div>
                                                    <div className="element__form-group-content">
                                                      <Field
                                                        as="select"
                                                        // disabled={this.props.fetchFavoriteComplete && index === 0}
                                                        name={`POLICYHOLDERS[${index}].POLICYHOLDER_OCCUPATION_DOMAIN_ID`}
                                                        id="career-category-select"
                                                        className="element__select"
                                                        onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                                                          this.handleOccupationDomainChange(e, index, setFieldValue);
                                                          handleChange(`POLICYHOLDERS[${index}].POLICYHOLDER_OCCUPATION_DOMAIN_ID`)(e);
                                                          index === 0 && this.handleSetSelfInsured(
                                                            e.currentTarget.value, values.INSUREDS, 'INSURED_OCCUPATION_DOMAIN_ID', setFieldValue,
                                                            'INSURED_OCCUPATION_DOMAIN_ID_NAME', e.currentTarget.selectedOptions.item(0)?.text);
                                                        }}
                                                      >
                                                        <option value="">請選擇</option>
                                                        {
                                                          this.state.occupations.length > 0 && (
                                                            _.map(this.state.occupations, (occupation: Occupation, occuIndex: number) => {
                                                              return <option key={occuIndex} value={occupation.OCCUPATION_DOMAIN_ID}>{occupation.OCCUPATION_NAME}</option>;
                                                            })
                                                          )
                                                        }
                                                      </Field>
                                                      <Field
                                                        as="select"
                                                        name={`POLICYHOLDERS[${index}].POLICYHOLDER_OCCUPATION_ID`}
                                                        id="career-items-select"
                                                        className="element__select"
                                                        // disabled={(this.props.fetchFavoriteComplete && index === 0) || policyholder.POLICYHOLDER_OCCUPATION_DOMAIN_ID !== OccupationIdType.Special}
                                                        disabled={policyholder.POLICYHOLDER_OCCUPATION_DOMAIN_ID !== OccupationIdType.Special}
                                                        onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                                                          commonService.setSelectOptName(setFieldValue, `POLICYHOLDERS[${index}].POLICYHOLDER_OCCUPATION_ID_NAME`, e.currentTarget.selectedOptions.item(0)?.text);
                                                          handleChange(`POLICYHOLDERS[${index}].POLICYHOLDER_OCCUPATION_ID`)(e);
                                                          index === 0 && this.handleSetSelfInsured(
                                                            e.currentTarget.value, values.INSUREDS, 'INSURED_OCCUPATION_ID', setFieldValue,
                                                            'INSURED_OCCUPATION_ID_NAME', e.currentTarget.selectedOptions.item(0)?.text);
                                                        }}
                                                      >
                                                        <option value="">請選擇</option>
                                                        {
                                                          this.handleCreateOccupationOpts(policyholder.POLICYHOLDER_OCCUPATION_DOMAIN_ID)
                                                        }
                                                      </Field>
                                                    </div>
                                                    <div className="element__error-message">
                                                      {
                                                        getIn(errors, `POLICYHOLDERS[${index}].POLICYHOLDER_OCCUPATION_DOMAIN_ID`) && getIn(touched, `POLICYHOLDERS[${index}].POLICYHOLDER_OCCUPATION_DOMAIN_ID`)
                                                          ? <ErrorMessage name={`POLICYHOLDERS[${index}].POLICYHOLDER_OCCUPATION_DOMAIN_ID`} />
                                                          : getIn(errors, `POLICYHOLDERS[${index}].POLICYHOLDER_OCCUPATION_ID`) && getIn(touched, `POLICYHOLDERS[${index}].POLICYHOLDER_OCCUPATION_ID`)
                                                            ? <ErrorMessage name={`POLICYHOLDERS[${index}].POLICYHOLDER_OCCUPATION_ID`} />
                                                            : ''
                                                      }
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            )
                                          }
                                          <div className="element__form-table-tr">
                                            <div className="element__form-table-td">
                                              {/* 要保人繳交保險費之資金來源為 */}
                                              <FieldArray name={`POLICYHOLDERS[${index}].POLICYHOLDER_KYC_INFOS`}>
                                                {
                                                  () => (
                                                    <>
                                                      {
                                                        policyholder.POLICYHOLDER_KYC_INFOS.length > 0 && (
                                                          _.map(policyholder.POLICYHOLDER_KYC_INFOS, (kycInfo: PolicyholderKycInfo, infoIndex: number) => {
                                                            return (
                                                              <div
                                                                className={'element__form-group' + (
                                                                  (getIn(errors, `POLICYHOLDERS[${index}].POLICYHOLDER_KYC_INFOS[${infoIndex}].KYC_ANSWER.KEY`) && getIn(touched, `POLICYHOLDERS[${index}].POLICYHOLDER_KYC_INFOS[${infoIndex}].KYC_ANSWER.KEY`)) ||
                                                                    (getIn(errors, `POLICYHOLDERS[${index}].POLICYHOLDER_KYC_INFOS[${infoIndex}].KYC_ANSWER.INPUT_VAL`) && getIn(touched, `POLICYHOLDERS[${index}].POLICYHOLDER_KYC_INFOS[${infoIndex}].KYC_ANSWER.INPUT_VAL`))
                                                                    ? ' element__form-group--invalid' : '')}
                                                                key={infoIndex}
                                                              >
                                                                <div className="element__form-group-title">{`${kycInfo.KYC_SUBJECT}*`}</div>
                                                                <div className="element__form-group-content">
                                                                  {
                                                                    _.map(kycInfo.KYC_OPTIONS, (kycOpt: KycOptionContent, kycOptIndex: number) => {
                                                                      return (
                                                                        <div className="element__radio-group" key={kycOptIndex}>
                                                                          <label htmlFor={`POLICYHOLDERS[${index}].POLICYHOLDER_KYC_INFOS[${infoIndex}].KYC_OPTIONS[${kycOptIndex}].checkbox`}>
                                                                            <div className="element__radio">
                                                                              <Field
                                                                                type="radio"
                                                                                name={`POLICYHOLDERS[${index}].POLICYHOLDER_KYC_INFOS[${infoIndex}].KYC_ANSWER.KEY`}
                                                                                id={`POLICYHOLDERS[${index}].POLICYHOLDER_KYC_INFOS[${infoIndex}].KYC_OPTIONS[${kycOptIndex}].checkbox`}
                                                                                value={kycOpt.KEY}
                                                                                onClick={(e: React.ChangeEvent<HTMLInputElement>) => {
                                                                                  if (e.currentTarget.value !== '99') {
                                                                                    setFieldValue(`POLICYHOLDERS[${index}].POLICYHOLDER_KYC_INFOS[${infoIndex}].KYC_ANSWER.INPUT_VAL`, '');
                                                                                  }
                                                                                  setFieldValue(`POLICYHOLDERS[${index}].POLICYHOLDER_KYC_INFOS[${infoIndex}].KYC_ANSWER.TEXT`, kycOpt.VAL);
                                                                                  // setFieldValue(`POLICYHOLDERS[${index}].POLICYHOLDER_KYC_INFOS[${infoIndex}].KYC_OPTIONS[${kycOptIndex}].CHECKED`, e.currentTarget.checked);
                                                                                  handleChange(`POLICYHOLDERS[${index}].POLICYHOLDER_KYC_INFOS[${infoIndex}].KYC_ANSWER.KEY`)(e);
                                                                                }}
                                                                              />
                                                                              <div className="element__radio-btn" />
                                                                            </div>
                                                                            <span>{kycOpt.VAL}</span>
                                                                          </label>
                                                                          {
                                                                            kycOpt.KEY === '99' && (
                                                                              <Field
                                                                                type="text"
                                                                                name={`POLICYHOLDERS[${index}].POLICYHOLDER_KYC_INFOS[${infoIndex}].KYC_ANSWER.INPUT_VAL`}
                                                                                className="element__input"
                                                                                disabled={policyholder.POLICYHOLDER_KYC_INFOS[infoIndex].KYC_ANSWER.KEY !== '99'}
                                                                                placeholder=""
                                                                              />
                                                                            )
                                                                          }
                                                                        </div>
                                                                      );
                                                                    })
                                                                  }
                                                                </div>
                                                                <div className="element__error-message">
                                                                  {
                                                                    getIn(errors, `POLICYHOLDERS[${index}].POLICYHOLDER_KYC_INFOS[${infoIndex}].KYC_ANSWER.KEY`) && getIn(touched, `POLICYHOLDERS[${index}].POLICYHOLDER_KYC_INFOS[${infoIndex}].KYC_ANSWER.KEY`)
                                                                      ? <ErrorMessage name={`POLICYHOLDERS[${index}].POLICYHOLDER_KYC_INFOS[${infoIndex}].KYC_ANSWER.KEY`} />
                                                                      : getIn(errors, `POLICYHOLDERS[${index}].POLICYHOLDER_KYC_INFOS[${infoIndex}].KYC_ANSWER.INPUT_VAL`) && getIn(touched, `POLICYHOLDERS[${index}].POLICYHOLDER_KYC_INFOS[${infoIndex}].KYC_ANSWER.INPUT_VAL`)
                                                                        ? <ErrorMessage name={`POLICYHOLDERS[${index}].POLICYHOLDER_KYC_INFOS[${infoIndex}].KYC_ANSWER.INPUT_VAL`} />
                                                                        : ''
                                                                  }
                                                                </div>
                                                              </div>
                                                            );
                                                          })
                                                        )
                                                      }
                                                    </>
                                                  )
                                                }
                                              </FieldArray>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  );
                                })
                              )
                            }
                            <div className="policyholder-info__controls">
                              <button
                                type="button"
                                className="element__icon-button element__icon-button--add"
                                onClick={() => this.handleAddPolicyholder(values, push, setFieldValue)}
                              >
                                新增要保人
                              </button>
                            </div>
                          </>
                        )
                      }
                    </FieldArray>
                  </div>
                </div>
                {/* 被保險人資料 */}
                <div className="insured-info" data-fieldname="INSUREDS" tabIndex={2} style={{ outline: 'none' }}>
                  <div className="insured-info__title">
                    <span>被保險人資料</span>
                    <p>*網路投保/要保受益人關係限定法繼承人</p>
                  </div>
                  <div className="insured-info__content">
                    <FieldArray name="INSUREDS">
                      {
                        ({ push, remove }) => (
                          <>
                            {
                              values.INSUREDS && values.INSUREDS.length > 0 && (
                                _.map(values.INSUREDS, (insured: BaseFireInsuredContent, index: number) => {
                                  return (
                                    <div className="insured-info__item" key={index} ref={index === values.INSUREDS.length - 1 ? this.lastInsuredRef : null}>
                                      <div className="insured-info__form">
                                        {
                                          index !== 0 && (
                                            <button
                                              type="button"
                                              className="insured-info__item-delete-btn"
                                              onClick={() => remove(index)}
                                            />
                                          )
                                        }
                                        <div className="element__form-table">
                                          <div className="element__form-table-tr">
                                            <div className="element__form-table-td">
                                              {/* 與要保人關係 */}
                                              <div className={'element__form-group' + (getIn(errors, `INSUREDS[${index}].INSURED_RELATION`) && getIn(touched, `INSUREDS[${index}].INSURED_RELATION`) ? ' element__form-group--invalid' : '')}>
                                                <div className="element__form-group-title">與要保人關係* <span className="ant-picker-exam-info">要保人為多人時，以第一人為主</span></div>
                                                <Field
                                                  as="select"
                                                  name={`INSUREDS[${index}].INSURED_RELATION`}
                                                  className="element__select"
                                                  onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                                                    this.handleInsuredRelationChange(index, e, values.INSUREDS);
                                                  }}
                                                >
                                                  <option value="">請選擇</option>
                                                  {
                                                    this.handleGetRelationOpts(values.POLICYHOLDERS)
                                                  }
                                                </Field>
                                                <div className="element__error-message">
                                                  <ErrorMessage name={`INSUREDS[${index}].INSURED_RELATION`} />
                                                </div>
                                              </div>
                                            </div>
                                            <div className="element__form-table-td">
                                              {/* 被保人姓名 */}
                                              <div className={'element__form-group' + (getIn(errors, `INSUREDS[${index}].INSURED_NAME`) && getIn(touched, `INSUREDS[${index}].INSURED_NAME`) ? ' element__form-group--invalid' : '')}>
                                                <div className="element__form-group-title">被保人姓名*</div>
                                                <Field
                                                  type="text"
                                                  name={`INSUREDS[${index}].INSURED_NAME`}
                                                  className="element__input"
                                                  autoComplete="off"
                                                  maxLength={200}
                                                  disabled={insured.INSURED_RELATION === InsuredRelation.Self || insured.INSURED_RELATION === InsuredRelation.SameInsured}
                                                />
                                                <div className="element__error-message">
                                                  <ErrorMessage name={`INSUREDS[${index}].INSURED_NAME`} />
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div className="element__form-table-tr">
                                            {
                                              insured.INSURED_RELATION !== InsuredRelation.Self && insured.INSURED_RELATION !== InsuredRelation.SameInsured && (
                                                <div className="element__form-table-td">
                                                  {/* 身份別 */}
                                                  <div className={'element__form-group' + (getIn(errors, `INSUREDS[${index}].INSURED_NATIONALITY_TYPE`) && getIn(touched, `INSUREDS[${index}].INSURED_NATIONALITY_TYPE`) ? ' element__form-group--invalid' : '')}>
                                                    <div className="element__form-group-title">證件類別*</div>
                                                    <div className="element__form-group-content">
                                                      {
                                                        this.state.nationalityVSysOpts.length > 0 && (
                                                          _.map(this.state.nationalityVSysOpts, (sysOpt: SysOption, sysIndex: number) => {
                                                            return (
                                                              <div className="element__radio-group" key={sysIndex}>
                                                                <label htmlFor={`nationality-radio-${sysOpt.PARAM_VALUE}-insured-${index}-${sysIndex}`}>
                                                                  <div className="element__radio">
                                                                    <Field
                                                                      type="radio"
                                                                      name={`INSUREDS[${index}].INSURED_NATIONALITY_TYPE`}
                                                                      id={`nationality-radio-${sysOpt.PARAM_VALUE}-insured-${index}-${sysIndex}`}
                                                                      value={sysOpt.PARAM_VALUE}
                                                                      onClick={(e: React.MouseEvent<HTMLInputElement>) => {
                                                                        if (insured.INSURED_NATIONALITY_TYPE !== e.currentTarget.value) {
                                                                          if (e.currentTarget.value === NationalType.Legal) {
                                                                            setFieldValue(`INSUREDS[${index}].INSURED_BIRTHDAY`, '');
                                                                            setFieldValue(`INSUREDS[${index}].INSURED_OCCUPATION_DOMAIN_ID`, '');
                                                                            setFieldValue(`INSUREDS[${index}].INSURED_OCCUPATION_DOMAIN_ID_NAME`, '');
                                                                            setFieldValue(`INSUREDS[${index}].INSURED_OCCUPATION_ID`, '');
                                                                            setFieldValue(`INSUREDS[${index}].INSURED_OCCUPATION_ID_NAME`, '');
                                                                          }

                                                                          this.handleValidID(insured.INSURED_ID, e.currentTarget.value, index, `INSUREDS[${index}].INSURED_ID`, `INSUREDS[${index}].INSURED_ID_ERRMSG`);
                                                                        }
                                                                      }}
                                                                    />
                                                                    <div className="element__radio-btn" />
                                                                  </div>
                                                                  <span>{sysOpt.PARAM_TEXT}</span>
                                                                </label>
                                                              </div>
                                                            );
                                                          })
                                                        )
                                                      }
                                                    </div>
                                                    <div className="element__error-message">
                                                      <ErrorMessage name={`INSUREDS[${index}].INSURED_NATIONALITY_TYPE`} />
                                                    </div>
                                                  </div>
                                                </div>
                                              )
                                            }
                                          </div>
                                          <div className="element__form-table-tr">
                                            {
                                              insured.INSURED_RELATION !== InsuredRelation.Self && insured.INSURED_RELATION !== InsuredRelation.SameInsured && (
                                                <>
                                                  <div className="element__form-table-td">
                                                    {/* 身分證字號 (居留證號碼) */}
                                                    <div className={'element__form-group' + (getIn(errors, `INSUREDS[${index}].INSURED_ID`) && getIn(touched, `INSUREDS[${index}].INSURED_ID`) ? ' element__form-group--invalid' : '')}>
                                                      <div className="element__form-group-title">{handleGetNationalityType(insured.INSURED_NATIONALITY_TYPE)}*</div>
                                                      <Field
                                                        type="text"
                                                        name={`INSUREDS[${index}].INSURED_ID`}
                                                        className="element__input"
                                                        autoComplete="off"
                                                        maxLength={10}
                                                        validate={(val: string) => {
                                                          return insured.INSURED_ID_ERRMSG || handleValidateInsuredId(val, values.INSUREDS, insured.INSURED_RELATION, values.POLICYHOLDERS[0], index);
                                                        }}
                                                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                                          const val = e.currentTarget.value ? e.currentTarget.value.toUpperCase() : e.currentTarget.value;
                                                          this.handleValidID(val, insured.INSURED_NATIONALITY_TYPE, index, `INSUREDS[${index}].INSURED_ID`, `INSUREDS[${index}].INSURED_ID_ERRMSG`);
                                                          setFieldTouched(`INSUREDS[${index}].INSURED_ID`, true);
                                                          const errMsg = handleValidateInsuredId(val, values.INSUREDS, insured.INSURED_RELATION, values.POLICYHOLDERS[0], index);
                                                          if (errMsg) {
                                                            sweetAlertService.modal({
                                                              icon: SweetAlertIcon.Info,
                                                              html: errMsg
                                                            });
                                                          }
                                                          handleChange(`INSUREDS[${index}].INSURED_ID`)(e);
                                                          setFieldValue(`INSUREDS[${index}].INSURED_ID`, val);
                                                        }}
                                                      />
                                                      <div className="element__error-message">
                                                        <ErrorMessage name={`INSUREDS[${index}].INSURED_ID`} />
                                                      </div>
                                                    </div>
                                                  </div>
                                                  {index === 0 ? (
                                                    <div className="element__form-table-td">
                                                      {/* 生日 */}
                                                      {
                                                        insured.INSURED_NATIONALITY_TYPE !== NationalType.Legal && (
                                                          <div className={'element__form-group' + (getIn(errors, `INSUREDS[${index}].INSURED_BIRTHDAY`) && getIn(touched, `INSUREDS[${index}].INSURED_BIRTHDAY`) ? ' element__form-group--invalid' : '')}>
                                                            <div className="element__form-group-title">生日 <span className="ant-picker-exam-info">範例： 20200101</span></div>
                                                            <div className="element__form-group-content">
                                                              <DatePicker
                                                                name={`INSUREDS[${index}].INSURED_BIRTHDAY`}
                                                                className="element__input"
                                                                format="YYYYMMDD"
                                                                showToday={false}
                                                                disabledDate={(current: any) => {
                                                                  return current && (current > moment().add(-1, 'days') || current < moment('1911/01/01'));
                                                                  // return currentDate && (currentDate > moment(new Date()).add(-1, 'days') || currentDate < moment('1911/01/01'));
                                                                }}
                                                                validate={(val) => {
                                                                  return handleValidateInsuredBirthday(values.POLICYHOLDERS, insured.INSURED_ID, val);
                                                                }}
                                                                onChange={(val: any) => {
                                                                  const errMsg = handleValidateInsuredBirthday(values.POLICYHOLDERS, insured.INSURED_ID, val);
                                                                  if (errMsg) {
                                                                    sweetAlertService.modal({
                                                                      icon: SweetAlertIcon.Info,
                                                                      html: errMsg
                                                                    });
                                                                  }
                                                                }}
                                                              />
                                                            </div>
                                                            <div className="element__error-message">
                                                              <ErrorMessage name={`INSUREDS[${index}].INSURED_BIRTHDAY`} />
                                                            </div>
                                                          </div>
                                                        )
                                                      }
                                                    </div>
                                                  ) : (
                                                    <div className="element__form-table-td" />
                                                  )}
                                                </>
                                              )
                                            }
                                          </div>
                                          {/* UI 修改: 被保人第二位(包含)後隱藏手機跟信箱 */}
                                          <div className="element__form-table-tr">
                                            {
                                              insured.INSURED_RELATION !== InsuredRelation.Self && insured.INSURED_RELATION !== InsuredRelation.SameInsured && index === 0 && (
                                                <>
                                                  <div className="element__form-table-td">
                                                    {/* 手機號碼 */}
                                                    <div className={'element__form-group' + (getIn(errors, `INSUREDS[${index}].INSURED_MOBILE`) && getIn(touched, `INSUREDS[${index}].INSURED_MOBILE`) ? ' element__form-group--invalid' : '')}>
                                                      <div className="element__form-group-title">手機號碼</div>
                                                      <Field
                                                        component={InputWithRegex}
                                                        name={`INSUREDS[${index}].INSURED_MOBILE`}
                                                        className="element__input"
                                                        autoComplete="off"
                                                        maxLength={10}
                                                        onBlur={(e: React.ChangeEvent<HTMLInputElement>) => {
                                                          handleBlur(e);
                                                          setFieldTouched(`INSUREDS[${index}].INSURED_MOBILE`, true);
                                                        }}
                                                      />
                                                      <div className="element__error-message">
                                                        <ErrorMessage name={`INSUREDS[${index}].INSURED_MOBILE`} />
                                                      </div>
                                                    </div>
                                                  </div>
                                                  <div className="element__form-table-td">
                                                    {/* 電子信箱 */}
                                                    <div className={'element__form-group' + (getIn(errors, `INSUREDS[${index}].INSURED_EMAIL_ADDR`) && getIn(touched, `INSUREDS[${index}].INSURED_EMAIL_ADDR`) ? ' element__form-group--invalid' : '')}>
                                                      <div className="element__form-group-title">電子信箱</div>
                                                      <AutoComplete
                                                        name={`INSUREDS[${index}].INSURED_EMAIL_ADDR`}
                                                        id={`INSUREDS[${index}].INSURED_EMAIL_ADDR`}
                                                        className="element__antd-input"
                                                        placeholder="請輸入電子信箱"
                                                        options={this.handleGetDomainSource(insured.INSURED_EMAIL_ADDR)}
                                                      />
                                                      <div className="element__error-message">
                                                        <ErrorMessage name={`INSUREDS[${index}].INSURED_EMAIL_ADDR`} />
                                                      </div>
                                                    </div>
                                                  </div>
                                                </>
                                              )
                                            }
                                          </div>
                                          <div className="element__form-table-tr">
                                            {
                                              insured.INSURED_RELATION !== InsuredRelation.Self && insured.INSURED_RELATION !== InsuredRelation.SameInsured && index === 0 && (
                                                <div className="element__form-table-td">
                                                  {/* 通訊地址 */}
                                                  <div className={'element__form-group' + (
                                                    (getIn(errors, `INSUREDS[${index}].INSURED_POST_CODE`) && getIn(touched, `INSUREDS[${index}].INSURED_POST_CODE`)) ||
                                                      (getIn(errors, `INSUREDS[${index}].INSURED_CITY_ID`) && getIn(touched, `INSUREDS[${index}].INSURED_CITY_ID`)) ||
                                                      (getIn(errors, `INSUREDS[${index}].INSURED_AREA_ID`) && getIn(touched, `INSUREDS[${index}].INSURED_AREA_ID`)) ||
                                                      (getIn(errors, `INSUREDS[${index}].INSURED_ADDRESS`) && getIn(touched, `INSUREDS[${index}].INSURED_ADDRESS`))
                                                      ? ' element__form-group--invalid'
                                                      : '')}
                                                  >
                                                    <div className="element__form-group-title">
                                                      {index === 0 ? (<span>通訊地址*</span>) : (<span>通訊地址</span>)}
                                                      <div className="element__checkbox-group">
                                                        <label htmlFor={`INSUREDS[${index}].SAME_INSURER.checkbox`}>
                                                          <div className="element__checkbox">
                                                            <Field
                                                              type="checkbox"
                                                              disabled={insured.INSURED_RELATION === InsuredRelation.Self}
                                                              name={`INSUREDS[${index}].SAME_INSURER`}
                                                              id={`INSUREDS[${index}].SAME_INSURER.checkbox`}
                                                              onClick={(e: React.ChangeEvent<HTMLInputElement>) => {
                                                                if (e.currentTarget.checked) {
                                                                  this.handleSameAddress(index, values.POLICYHOLDERS, setFieldValue);
                                                                }
                                                              }}
                                                            />
                                                            <div className="element__checkbox-btn" />
                                                          </div>
                                                          <span style={{ color: 'black' }}>同要保人 <span className="ant-picker-exam-info">要保人為多人時，以第一人為主</span></span>
                                                        </label>
                                                      </div>
                                                    </div>
                                                    <div className="element__form-group-content">
                                                      <AddressComponent
                                                        postCodeName={`INSUREDS[${index}].INSURED_POST_CODE`}
                                                        postCodeId="insured-postal-code-input"
                                                        cityIdName={`INSUREDS[${index}].INSURED_CITY_ID`}
                                                        cityId="insured-county-select"
                                                        cityIdVal={insured.INSURED_CITY_ID}
                                                        cityIdText={`INSUREDS[${index}].INSURED_CITY_NAME`}
                                                        areaIdName={`INSUREDS[${index}].INSURED_AREA_ID`}
                                                        areaId="insured-district-select"
                                                        areaIdVal={insured.INSURED_AREA_ID}
                                                        areaNameVal={insured.INSURED_AREA_NAME}
                                                        areaIdText={`INSUREDS[${index}].INSURED_AREA_NAME`}
                                                        addressName={`INSUREDS[${index}].INSURED_ADDRESS`}
                                                        addressId="insured-address-input"
                                                        postcodes={this.props.postcodes}
                                                        handleBlur={handleBlur}
                                                        handleChange={handleChange}
                                                        setFieldValue={setFieldValue}
                                                        disabled={Boolean(insured.SAME_INSURER)}
                                                      />
                                                    </div>
                                                    <div className="element__error-message">
                                                      {
                                                        getIn(errors, `INSUREDS[${index}].INSURED_POST_CODE`) && getIn(touched, `INSUREDS[${index}].INSURED_POST_CODE`)
                                                          ? <ErrorMessage name={`INSUREDS[${index}].INSURED_POST_CODE`} />
                                                          : getIn(errors, `INSUREDS[${index}].INSURED_CITY_ID`) && getIn(touched, `INSUREDS[${index}].INSURED_CITY_ID`)
                                                            ? <ErrorMessage name={`INSUREDS[${index}].INSURED_CITY_ID`} />
                                                            : getIn(errors, `INSUREDS[${index}].INSURED_AREA_ID`) && getIn(touched, `INSUREDS[${index}].INSURED_AREA_ID`)
                                                              ? <ErrorMessage name={`INSUREDS[${index}].INSURED_AREA_ID`} />
                                                              : getIn(errors, `INSUREDS[${index}].INSURED_ADDRESS`) && getIn(touched, `INSUREDS[${index}].INSURED_ADDRESS`)
                                                                ? <ErrorMessage name={`INSUREDS[${index}].INSURED_ADDRESS`} />
                                                                : ''
                                                      }
                                                    </div>
                                                  </div>
                                                </div>
                                              )
                                            }
                                          </div>
                                          <div className="element__form-table-tr">
                                            {
                                              insured.INSURED_NATIONALITY_TYPE !== NationalType.Legal && insured.INSURED_RELATION !== InsuredRelation.Self && insured.INSURED_RELATION !== InsuredRelation.SameInsured && (

                                                <div className="element__form-table-td">
                                                  {/* 職業類別 */}
                                                  <div className={'element__form-group' + (
                                                    (getIn(errors, `INSUREDS[${index}].INSURED_OCCUPATION_DOMAIN_ID`) && getIn(touched, `INSUREDS[${index}].INSURED_OCCUPATION_DOMAIN_ID`)) ||
                                                      (getIn(errors, `INSUREDS[${index}].INSURED_OCCUPATION_ID`) && getIn(touched, `INSUREDS[${index}].INSURED_OCCUPATION_ID`))
                                                      ? ' element__form-group--invalid' : '')}
                                                  >
                                                    <div className="element__form-group-title">職業類別*</div>
                                                    <div className="element__form-group-content">
                                                      <Field
                                                        as="select"
                                                        name={`INSUREDS[${index}].INSURED_OCCUPATION_DOMAIN_ID`}
                                                        id="career-category-select"
                                                        className="element__select"
                                                        onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                                                          this.handleInsuredOccupationDomainChange(e, index, setFieldValue);
                                                          handleChange(`INSUREDS[${index}].INSURED_OCCUPATION_DOMAIN_ID`)(e);
                                                        }}
                                                      >
                                                        <option value="">請選擇</option>
                                                        {
                                                          this.state.occupations.length > 0 && (
                                                            _.map(this.state.occupations, (occupation: Occupation, occuIndex: number) => {
                                                              return <option key={occuIndex} value={occupation.OCCUPATION_DOMAIN_ID}>{occupation.OCCUPATION_NAME}</option>;
                                                            })
                                                          )
                                                        }
                                                      </Field>
                                                      <Field
                                                        as="select"
                                                        name={`INSUREDS[${index}].INSURED_OCCUPATION_ID`}
                                                        id="career-items-select"
                                                        className="element__select"
                                                        disabled={insured.INSURED_OCCUPATION_DOMAIN_ID !== OccupationIdType.Special}
                                                        onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                                                          commonService.setSelectOptName(setFieldValue, `INSUREDS[${index}].INSURED_OCCUPATION_ID_NAME`, e.currentTarget.selectedOptions.item(0)?.text);
                                                          handleChange(`INSUREDS[${index}].INSURED_OCCUPATION_ID`)(e);
                                                        }}
                                                      >
                                                        <option value="">請選擇</option>
                                                        {
                                                          this.handleCreateOccupationOpts(insured.INSURED_OCCUPATION_DOMAIN_ID)
                                                        }
                                                      </Field>
                                                    </div>
                                                    <div className="element__error-message">
                                                      {
                                                        getIn(errors, `INSUREDS[${index}].INSURED_OCCUPATION_DOMAIN_ID`) && getIn(touched, `INSUREDS[${index}].INSURED_OCCUPATION_DOMAIN_ID`)
                                                          ? <ErrorMessage name={`INSUREDS[${index}].INSURED_OCCUPATION_DOMAIN_ID`} />
                                                          : getIn(errors, `INSUREDS[${index}].INSURED_OCCUPATION_ID`) && getIn(touched, `INSUREDS[${index}].INSURED_OCCUPATION_ID`)
                                                            ? <ErrorMessage name={`INSUREDS[${index}].INSURED_OCCUPATION_ID`} />
                                                            : ''
                                                      }
                                                    </div>
                                                  </div>
                                                </div>
                                              )
                                            }
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  );
                                })
                              )
                            }
                            <div className="insured-info__controls">
                              <button
                                type="button"
                                className="element__icon-button element__icon-button--add"
                                onClick={() => this.handleAddInsured(values, push)}
                              >
                                新增被保人
                              </button>
                            </div>
                          </>
                        )
                      }
                    </FieldArray>
                  </div>
                </div>
                {/* 抵押權資料 */}
                {
                  values.HAS_MORTGAGE === YesNoType.Yes && (
                    <div className="mortgage-info">
                      <div className="mortgage-info__title">抵押權資料</div>
                      <div className="mortgage-info__content">
                        <div className="mortgage-info__row">
                          {/* 是否為貸款戶 */}
                          <div className="element__form-group" data-fieldname="LENDER" tabIndex={3} style={{ outline: 'none' }}>
                            <div className="element__form-group-title">是否為貸款戶*</div>
                            <div className="element__form-group-content">
                              {
                                this.state.mortgageStatusSysOpts.length > 0 && (
                                  _.map(this.state.mortgageStatusSysOpts, (sysOpt: SysOption, index: number) => {
                                    return (
                                      <div className="element__radio-group" key={index}>
                                        <label htmlFor={`lender-radio-${sysOpt.PARAM_VALUE}`}>
                                          <div className="element__radio">
                                            <Field
                                              type="radio"
                                              name="LENDER"
                                              id={`lender-radio-${sysOpt.PARAM_VALUE}`}
                                              value={sysOpt.PARAM_VALUE}
                                              onClick={(e: React.MouseEvent<HTMLInputElement>) => {
                                                if (values.LENDER !== e.currentTarget.value) {
                                                  setFieldValue('MORTGAGEE_CODE', '');
                                                  setFieldValue('MORTGAGEE_BANK', '');
                                                  setFieldValue('MORTGAGEE_BANK_NAME', '');
                                                  setFieldValue('MORTGAGEE_BANK_BRANCH', '');
                                                  setFieldValue('MORTGAGEE_BANK_BRANCH_NAME', '');
                                                  setFieldValue('SEND_MORTGAGEE_BANK', '');
                                                  setFieldValue('BANK_HANDLE_RECIPIENT', '');
                                                  setFieldValue('BANK_RECEIVING_POST_CODE', '');
                                                  setFieldValue('BANK_RECEIVING_CITY_ID', '');
                                                  setFieldValue('BANK_CITY_NAME', '');
                                                  setFieldValue('BANK_RECEIVING_AREA_ID', '');
                                                  setFieldValue('BANK_AREA_NAME', '');
                                                  setFieldValue('BANK_RECEIVING_ADDRESS', '');
                                                  if (e.currentTarget.value === YesNo.Yes) {
                                                    setFieldValue('DELIVERY', PolicyDelivery.Paper);
                                                  }

                                                  if (e.currentTarget.value === YesNo.No) {
                                                    setFieldValue('DELIVERY', PolicyDelivery.Electric);
                                                  }
                                                  this.setState({ activeMortgageBank: '' });
                                                }
                                              }}
                                            />
                                            <div className="element__radio-btn" />
                                          </div>
                                          <span>{sysOpt.PARAM_TEXT}</span>
                                        </label>
                                      </div>
                                    );
                                  })
                                )
                              }
                            </div>
                            <div className="element__error-message">
                              <ErrorMessage name="LENDER" />
                            </div>
                          </div>
                        </div>
                        {
                          values.LENDER === YesNo.Yes && (
                            <>
                              <div className="mortgage-info__row">
                                {/* 抵押權人 */}
                                <div className={'element__form-group' + (
                                  (errors.MORTGAGEE_CODE && touched.MORTGAGEE_CODE) ||
                                    (errors.MORTGAGEE_BANK && touched.MORTGAGEE_BANK) ||
                                    (errors.MORTGAGEE_BANK_BRANCH && touched.MORTGAGEE_BANK_BRANCH)
                                    ? ' element__form-group--invalid' : '')}
                                >
                                  <div className="element__form-group-title">抵押權人*</div>
                                  <div className="element__form-group-content">
                                    <Field
                                      component={InputWithRegex}
                                      regex={NumAndEnglishRegex}
                                      name="MORTGAGEE_CODE"
                                      data-fieldname="MORTGAGEE_CODE"
                                      tabIndex={4}
                                      id="mortgage-code-input"
                                      className="element__input"
                                      autoComplete="off"
                                      maxLength={3}
                                      onBlur={() => {
                                        setFieldTouched('MORTGAGEE_CODE', true);
                                      }}
                                      onChange={(val: any) => {
                                        handleGetBank(val, setFieldValue);
                                        handleChange(val);
                                      }}
                                    />
                                    <Field
                                      as="select"
                                      name="MORTGAGEE_BANK"
                                      id="mortgage-bank-select"
                                      className="element__select"
                                      data-fieldname="MORTGAGEE_BANK"
                                      tabIndex={5}
                                      onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                                        this.setState({ activeMortgageBank: e.currentTarget.value });
                                        commonService.setSelectOptName(setFieldValue, 'MORTGAGEE_BANK_NAME', e.currentTarget.selectedOptions.item(0)?.text);
                                        handleSetMortgageCode(e.currentTarget.value, setFieldValue);
                                        setFieldValue('MORTGAGEE_BANK_BRANCH', '');
                                        setFieldValue('MORTGAGEE_BANK_BRANCH_NAME', '');
                                        handleChange('MORTGAGEE_BANK')(e);
                                      }}
                                    >
                                      <option value="">請選擇</option>
                                      {handleCreateBankOpts()}
                                    </Field>
                                    <Field
                                      as="select"
                                      name="MORTGAGEE_BANK_BRANCH"
                                      id="mortgage-bank-branch-select"
                                      className="element__select"
                                      data-fieldname="MORTGAGEE_BANK_BRANCH"
                                      tabIndex={6}
                                      onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                                        commonService.setSelectOptName(setFieldValue, 'MORTGAGEE_BANK_BRANCH_NAME', e.currentTarget.selectedOptions.item(0)?.text);
                                        handleChange('MORTGAGEE_BANK_BRANCH')(e);
                                      }}
                                    >
                                      <option value="">請選擇</option>
                                      {handleCreateBankBranchOpts()}
                                    </Field>
                                  </div>
                                  <div className="element__error-message">
                                    {
                                      errors.MORTGAGEE_CODE && touched.MORTGAGEE_CODE
                                        ? <ErrorMessage name="MORTGAGEE_CODE" />
                                        : errors.MORTGAGEE_BANK && touched.MORTGAGEE_BANK
                                          ? <ErrorMessage name="MORTGAGEE_BANK" />
                                          : errors.MORTGAGEE_BANK_BRANCH && touched.MORTGAGEE_BANK_BRANCH
                                            ? <ErrorMessage name="MORTGAGEE_BANK_BRANCH" />
                                            : ''
                                    }
                                  </div>
                                </div>
                              </div>
                              <div className="mortgage-info__row">
                                {/* 保單正本及收據副本是否寄送抵押銀行 */}
                                <div className={'element__form-group' + (errors.SEND_MORTGAGEE_BANK && touched.SEND_MORTGAGEE_BANK ? ' element__form-group--invalid' : '')}>
                                  <div className="element__form-group-title" data-fieldname="SEND_MORTGAGEE_BANK" tabIndex={7} style={{ outline: 'none' }}>
                                    保單正本及收據副本是否寄送抵押銀行？*
                                  </div>
                                  <div className="element__form-group-content">
                                    {
                                      this.state.yesnoSysOpts.length > 0 && (
                                        _.map(this.state.yesnoSysOpts, (sysOpt: SysOption, index: number) => {
                                          return (
                                            <div className="element__radio-group" key={index}>
                                              <label htmlFor={`send-mortgage-bank-radio-${sysOpt.PARAM_VALUE}`}>
                                                <div className="element__radio">
                                                  <Field
                                                    type="radio"
                                                    name="SEND_MORTGAGEE_BANK"
                                                    id={`send-mortgage-bank-radio-${sysOpt.PARAM_VALUE}`}
                                                    value={sysOpt.PARAM_VALUE}
                                                    onClick={(e: React.MouseEvent<HTMLInputElement>) => {
                                                      if (values.SEND_MORTGAGEE_BANK !== e.currentTarget.value && e.currentTarget.value === YesNo.No) {
                                                        setFieldValue('BANK_HANDLE_RECIPIENT', '');
                                                        setFieldValue('BANK_RECEIVING_POST_CODE', '');
                                                        setFieldValue('BANK_RECEIVING_CITY_ID', '');
                                                        setFieldValue('BANK_CITY_NAME', '');
                                                        setFieldValue('BANK_RECEIVING_AREA_ID', '');
                                                        setFieldValue('BANK_AREA_NAME', '');
                                                        setFieldValue('BANK_RECEIVING_ADDRESS', '');
                                                      }
                                                    }}
                                                  />
                                                  <div className="element__radio-btn" />
                                                </div>
                                                <span>{sysOpt.PARAM_TEXT}</span>
                                              </label>
                                            </div>
                                          );
                                        })
                                      )
                                    }
                                  </div>
                                  <div className="element__error-message">
                                    <ErrorMessage name="SEND_MORTGAGEE_BANK" />
                                  </div>
                                </div>
                              </div>
                              {
                                values.SEND_MORTGAGEE_BANK === YesNo.Yes && (
                                  <>
                                    <div className="mortgage-info__row">
                                      {/* 銀行經辦收件人 */}
                                      <div className={'element__form-group' + (errors.BANK_HANDLE_RECIPIENT && touched.BANK_HANDLE_RECIPIENT ? ' element__form-group--invalid' : '')}>
                                        <div className="element__form-group-title">銀行經辦收件人*</div>
                                        <Field type="text" name="BANK_HANDLE_RECIPIENT" data-fieldname="BANK_HANDLE_RECIPIENT" tabIndex={8} id="bank-handle-recipient-input" className="element__input" />
                                        <div className="element__error-message">
                                          <ErrorMessage name="BANK_HANDLE_RECIPIENT" />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="mortgage-info__row">
                                      {/* 銀行收件地址 */}
                                      <div className={'element__form-group' + (
                                        (errors.BANK_RECEIVING_POST_CODE && touched.BANK_RECEIVING_POST_CODE) ||
                                          (errors.BANK_RECEIVING_CITY_ID && touched.BANK_RECEIVING_CITY_ID) ||
                                          (errors.BANK_RECEIVING_AREA_ID && touched.BANK_RECEIVING_AREA_ID) ||
                                          (errors.BANK_RECEIVING_ADDRESS && touched.BANK_RECEIVING_ADDRESS)
                                          ? ' element__form-group--invalid' : '')}
                                      >
                                        <div className="element__form-group-title">銀行收件地址*</div>
                                        <div className="element__form-group-content">
                                          <AddressComponent
                                            postCodeName="BANK_RECEIVING_POST_CODE"
                                            postCodeId="bank-receiving-post-code-input"
                                            postCodeIdTabIndex={9}
                                            cityIdName="BANK_RECEIVING_CITY_ID"
                                            cityId="bank-receiving-city-select"
                                            cityIdVal={values.BANK_RECEIVING_CITY_ID}
                                            cityIdText="BANK_CITY_NAME"
                                            cityIdTabIndex={10}
                                            areaIdName="BANK_RECEIVING_AREA_ID"
                                            areaId="bank-receiving-area-select"
                                            areaIdVal={values.BANK_RECEIVING_AREA_ID}
                                            areaNameVal={values.BANK_AREA_NAME}
                                            areaIdText="BANK_AREA_NAME"
                                            areaIdTabIndex={11}
                                            addressName="BANK_RECEIVING_ADDRESS"
                                            addressId="bank-receiving-address-input"
                                            addressIdTabIndex={12}
                                            postcodes={this.props.postcodes}
                                            handleBlur={handleBlur}
                                            handleChange={handleChange}
                                            setFieldValue={setFieldValue}
                                          />
                                        </div>
                                        <div className="element__error-message">
                                          {
                                            errors.BANK_RECEIVING_POST_CODE && touched.BANK_RECEIVING_POST_CODE
                                              ? <ErrorMessage name="BANK_RECEIVING_POST_CODE" />
                                              : errors.BANK_RECEIVING_CITY_ID && touched.BANK_RECEIVING_CITY_ID
                                                ? <ErrorMessage name="BANK_RECEIVING_CITY_ID" />
                                                : errors.BANK_RECEIVING_AREA_ID && touched.BANK_RECEIVING_AREA_ID
                                                  ? <ErrorMessage name="BANK_RECEIVING_AREA_ID" />
                                                  : errors.BANK_RECEIVING_ADDRESS && touched.BANK_RECEIVING_ADDRESS
                                                    ? <ErrorMessage name="BANK_RECEIVING_ADDRESS" />
                                                    : ''
                                          }
                                        </div>
                                      </div>
                                    </div>
                                  </>
                                )
                              }
                            </>
                          )
                        }
                      </div>
                    </div>
                  )
                }
                {/* 保單寄送方式 */}
                <div className="delivery">
                  <div className="delivery__title">保單寄送方式</div>
                  <div className="delivery__content">
                    <div className="element__form-group">
                      <div className="element__form-group-content">
                        {
                          this.state.policyDeliverySysOpts.length > 0 && (
                            _.map(this.state.policyDeliverySysOpts, (sysopt: SysOption, index: number) => {
                              return (
                                <div className="element__radio-group" key={index}>
                                  <label htmlFor={`paper-policy-radio${index}`}>
                                    <div className="element__radio">
                                      <Field
                                        type="radio"
                                        name="DELIVERY"
                                        id={`paper-policy-radio${index}`}
                                        value={sysopt.PARAM_VALUE}
                                        disabled={values.LENDER === YesNo.Yes}
                                      />
                                      <div className="element__radio-btn" />
                                    </div>
                                    <span>{sysopt.PARAM_TEXT}</span>
                                  </label>
                                  {
                                    sysopt.PARAM_VALUE === PolicyDelivery.Electric ? <a className="element__link" href={RouterSettings.MemberCenter.ElectronicPolicy} rel="noopener noreferrer" target="_blank">(說明)</a> : null
                                  }
                                </div>
                              );
                            })
                          )
                        }
                        {this.state.policyDeliverySysOpts.length === 2 &&
                          <>
                            <p>{commonService.getCodeMsg(this.props.UICodes, CodeId.U019)}</p>
                            <p>{commonService.getCodeMsg(this.props.UICodes, CodeId.U052)}</p>
                          </>}
                        {(this.state.policyDeliverySysOpts.length === 1 && this.state.policyDeliverySysOpts[0].PARAM_VALUE === PolicyDelivery.Electric)
                          ? <p>{commonService.getCodeMsg(this.props.UICodes, CodeId.U019)}</p>
                          : (this.state.policyDeliverySysOpts.length === 1)
                            ? <p>{commonService.getCodeMsg(this.props.UICodes, CodeId.U052)}</p>
                            : null}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="insure-process-fill__controls">
                <button type="button" className="element__button element__button--red-border" onClick={() => this.handleGoBack(values)}>返回上一頁</button>
                <button type="submit" className="element__button element__button--red">下一步</button>
              </div>
              <FormikFocusError />
              <MemberInfoErrorModal />
            </Form>
          )}
        </Formik>
      </div>
    );
  }
}

const mapStateToProps = (state: RootReducersState) => {
  return {
    fetchFavoriteComplete: state.myFavorite.fetchFavoriteComplete
  };
};

const mapDisatchToProps = (dispatch: Dispatch) => {
  return {
    setRuleValidErrorModalVisible: (visible: boolean, errorMsgs: string[]) => dispatch(setRuleValidErrorModalVisible(visible, errorMsgs)),
    setMemberInfoErrorModalVisible: (visible: boolean, title?: string, content?: string, fieldNames?: string[]) => dispatch(setMemberInfoErrorModalVisible(visible, title, content, fieldNames))
  };
};

export default connect(mapStateToProps, mapDisatchToProps)(InsureProcessFill);
